(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
	typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.icons_umd = {}, global.React));
})(this, (function (exports, React) { 'use strict';

	function _interopNamespaceDefault(e) {
		var n = Object.create(null);
		if (e) {
			Object.keys(e).forEach(function (k) {
				if (k !== 'default') {
					var d = Object.getOwnPropertyDescriptor(e, k);
					Object.defineProperty(n, k, d.get ? d : {
						enumerable: true,
						get: function () { return e[k]; }
					});
				}
			});
		}
		n.default = e;
		return Object.freeze(n);
	}

	var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

	var _path$2h;
	function _extends$2m() { return _extends$2m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2m.apply(null, arguments); }
	var SvgArrowClockwise = function SvgArrowClockwise(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2m({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2h || (_path$2h = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.5 5.25v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 1 1 0-1.5h2.568l-2.492-2.284-.024-.022a7.5 7.5 0 1 0-.157 10.76.75.75 0 1 1 1.032 1.09A8.95 8.95 0 0 1 11.999 21h-.123A9 9 0 1 1 18.35 5.625L21 8.044V5.25a.75.75 0 1 1 1.5 0"
	  })));
	};

	var _path$2g;
	function _extends$2l() { return _extends$2l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2l.apply(null, arguments); }
	var SvgArrowElbowDownRight = function SvgArrowElbowDownRight(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2l({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2g || (_path$2g = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.78 17.03-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H6.75A.75.75 0 0 1 6 16.5V3a.75.75 0 0 1 1.5 0v12.75h10.94l-3.22-3.22a.75.75 0 1 1 1.06-1.06l4.5 4.5a.747.747 0 0 1 0 1.06"
	  })));
	};

	var _path$2f;
	function _extends$2k() { return _extends$2k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2k.apply(null, arguments); }
	var SvgArrowLeft = function SvgArrowLeft(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2k({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2f || (_path$2f = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 12a.75.75 0 0 1-.75.75H5.56l5.47 5.47a.75.75 0 1 1-1.061 1.06l-6.75-6.75a.75.75 0 0 1 0-1.06l6.75-6.75a.75.75 0 1 1 1.061 1.06l-5.47 5.47h14.69A.75.75 0 0 1 21 12"
	  })));
	};

	var _path$2e;
	function _extends$2j() { return _extends$2j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2j.apply(null, arguments); }
	var SvgArrowMerge = function SvgArrowMerge(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2j({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2e || (_path$2e = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M3 6.75h6a.75.75 0 0 1 .53.22L14.56 12h4.63l-1.72-1.72a.75.75 0 1 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72h-4.63l-5.03 5.03a.75.75 0 0 1-.53.22H3a.75.75 0 1 1 0-1.5h5.69l4.5-4.5-4.5-4.5H3a.75.75 0 1 1 0-1.5"
	  })));
	};

	var _path$2d;
	function _extends$2i() { return _extends$2i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2i.apply(null, arguments); }
	var SvgArrowRight = function SvgArrowRight(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2i({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2d || (_path$2d = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.78 12.53-6.75 6.75a.75.75 0 0 1-1.06-1.06l5.47-5.47H3.75a.75.75 0 1 1 0-1.5h14.69l-5.47-5.47a.75.75 0 1 1 1.06-1.06l6.75 6.75a.75.75 0 0 1 0 1.06"
	  })));
	};

	var _path$2c;
	function _extends$2h() { return _extends$2h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2h.apply(null, arguments); }
	var SvgArrowSquareOut = function SvgArrowSquareOut(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2h({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2c || (_path$2c = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 9.75a.75.75 0 1 1-1.5 0V5.561l-6.218 6.22a.75.75 0 1 1-1.062-1.062L18.44 4.5h-4.19a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 .75.75zM17.25 12a.75.75 0 0 0-.75.75v6.75h-12v-12h6.75a.75.75 0 1 0 0-1.5H4.5A1.5 1.5 0 0 0 3 7.5v12A1.5 1.5 0 0 0 4.5 21h12a1.5 1.5 0 0 0 1.5-1.5v-6.75a.75.75 0 0 0-.75-.75"
	  })));
	};

	var _path$2b;
	function _extends$2g() { return _extends$2g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2g.apply(null, arguments); }
	var SvgArrowUUpLeft = function SvgArrowUUpLeft(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2g({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2b || (_path$2b = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 13.5a6.006 6.006 0 0 1-6 6H7.5a.75.75 0 0 1 0-1.5h8.25a4.5 4.5 0 1 0 0-9H4.81l3.22 3.22a.75.75 0 1 1-1.061 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5A.75.75 0 1 1 8.03 4.28L4.81 7.5h10.94a6.006 6.006 0 0 1 6 6"
	  })));
	};

	var _path$2a;
	function _extends$2f() { return _extends$2f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2f.apply(null, arguments); }
	var SvgArrowUpLeft = function SvgArrowUpLeft(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2f({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2a || (_path$2a = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M18.53 18.53a.747.747 0 0 1-1.06 0L6.75 7.81v7.94a.75.75 0 1 1-1.5 0V6A.75.75 0 0 1 6 5.25h9.75a.75.75 0 1 1 0 1.5H7.81l10.72 10.72a.747.747 0 0 1 0 1.06"
	  })));
	};

	var _path$29;
	function _extends$2e() { return _extends$2e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2e.apply(null, arguments); }
	var SvgArrowUpRight = function SvgArrowUpRight(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2e({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$29 || (_path$29 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M18.75 6v9.75a.75.75 0 1 1-1.5 0V7.81L6.531 18.53a.75.75 0 1 1-1.061-1.06L16.19 6.75H8.25a.75.75 0 1 1 0-1.5H18a.75.75 0 0 1 .75.75"
	  })));
	};

	var _path$28;
	function _extends$2d() { return _extends$2d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2d.apply(null, arguments); }
	var SvgArrowsHorizontalLeft = function SvgArrowsHorizontalLeft(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2d({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$28 || (_path$28 = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M5.78 8.47a.75.75 0 0 1 0 1.06l-1.72 1.72h17.69a.75.75 0 0 1 0 1.5H4.06l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0",
	    clipRule: "evenodd"
	  })));
	};

	var _path$27;
	function _extends$2c() { return _extends$2c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2c.apply(null, arguments); }
	var SvgArrowsHorizontalRight = function SvgArrowsHorizontalRight(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2c({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$27 || (_path$27 = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M18.22 8.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H2.25a.75.75 0 0 1 0-1.5h17.69l-1.72-1.72a.75.75 0 0 1 0-1.06",
	    clipRule: "evenodd"
	  })));
	};

	var _path$26;
	function _extends$2b() { return _extends$2b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2b.apply(null, arguments); }
	var SvgBarcode = function SvgBarcode(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2b({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$26 || (_path$26 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 4.5v3.75a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5H21a.75.75 0 0 1 .75.75m-15 14.25h-3v-3a.75.75 0 1 0-1.5 0v3.75a.75.75 0 0 0 .75.75h3.75a.75.75 0 1 0 0-1.5M21 15a.75.75 0 0 0-.75.75v3h-3a.75.75 0 1 0 0 1.5H21a.75.75 0 0 0 .75-.75v-3.75A.75.75 0 0 0 21 15M3 9a.75.75 0 0 0 .75-.75v-3h3a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0-.75.75v3.75A.75.75 0 0 0 3 9m4.5-1.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 1 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75m9.75 8.25v-7.5a.75.75 0 1 0-1.5 0v7.5a.75.75 0 1 0 1.5 0M13.5 7.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 1 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75m-3 0a.75.75 0 0 0-.75.75v7.5a.75.75 0 1 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75"
	  })));
	};

	var _path$25;
	function _extends$2a() { return _extends$2a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2a.apply(null, arguments); }
	var SvgBasketFill = function SvgBasketFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2a({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$25 || (_path$25 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.313 7.756a.75.75 0 0 0-.563-.256h-4.16l-5.027-5.744a.75.75 0 0 0-1.126 0L6.41 7.5H2.25a.75.75 0 0 0-.743.85l1.412 10.599a1.506 1.506 0 0 0 1.487 1.301h15.188a1.506 1.506 0 0 0 1.487-1.301l1.413-10.6a.75.75 0 0 0-.181-.593M7.65 17.25h-.076a.75.75 0 0 1-.75-.675l-.525-5.25a.75.75 0 1 1 1.493-.15l.525 5.25a.75.75 0 0 1-.667.825m5.1-.75a.75.75 0 0 1-1.5 0v-5.25a.75.75 0 0 1 1.5 0zm-4.347-9L12 3.39l3.597 4.11zm9.293 3.825-.525 5.25a.75.75 0 0 1-.745.675h-.076a.75.75 0 0 1-.671-.821l.525-5.25a.75.75 0 0 1 1.492.15z"
	  })));
	};

	var _path$24;
	function _extends$29() { return _extends$29 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$29.apply(null, arguments); }
	var SvgBasket = function SvgBasket(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$29({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$24 || (_path$24 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12.75 11.25v5.25a.75.75 0 0 1-1.5 0v-5.25a.75.75 0 0 1 1.5 0m3.454-.075-.525 5.25a.75.75 0 0 0 .671.825q.037.003.076 0a.75.75 0 0 0 .745-.675l.525-5.25a.75.75 0 0 0-1.492-.15m-8.408 0a.75.75 0 1 0-1.492.15l.525 5.25a.75.75 0 0 0 .75.675q.037.003.076 0a.75.75 0 0 0 .671-.821zM22.494 8.35l-1.413 10.6a1.506 1.506 0 0 1-1.487 1.301H4.406A1.506 1.506 0 0 1 2.92 18.95L1.508 8.35a.75.75 0 0 1 .742-.85h4.16l5.027-5.744a.75.75 0 0 1 1.126 0L17.59 7.5h4.16a.75.75 0 0 1 .744.85M8.403 7.5h7.194L12 3.39zM20.893 9H3.107l1.3 9.75h15.187z"
	  })));
	};

	var _path$23;
	function _extends$28() { return _extends$28 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$28.apply(null, arguments); }
	var SvgBellFill = function SvgBellFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$28({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$23 || (_path$23 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.794 16.494c-.52-.896-1.294-3.432-1.294-6.744a7.5 7.5 0 0 0-15 0c0 3.313-.774 5.848-1.295 6.744A1.5 1.5 0 0 0 4.5 18.75h3.826a3.75 3.75 0 0 0 7.348 0H19.5a1.5 1.5 0 0 0 1.294-2.256M12 20.25a2.25 2.25 0 0 1-2.12-1.5h4.24a2.25 2.25 0 0 1-2.12 1.5"
	  })));
	};

	var _path$22;
	function _extends$27() { return _extends$27 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$27.apply(null, arguments); }
	var SvgBell = function SvgBell(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$27({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$22 || (_path$22 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.794 16.494c-.52-.896-1.294-3.432-1.294-6.744a7.5 7.5 0 0 0-15 0c0 3.313-.774 5.848-1.295 6.744A1.5 1.5 0 0 0 4.5 18.75h3.826a3.75 3.75 0 0 0 7.348 0H19.5a1.5 1.5 0 0 0 1.294-2.256M12 20.25a2.25 2.25 0 0 1-2.12-1.5h4.24a2.25 2.25 0 0 1-2.12 1.5m-7.5-3c.722-1.241 1.5-4.117 1.5-7.5a6 6 0 1 1 12 0c0 3.38.776 6.256 1.5 7.5z"
	  })));
	};

	var _path$21;
	function _extends$26() { return _extends$26 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$26.apply(null, arguments); }
	var SvgBookOpenText = function SvgBookOpenText(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$26({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$21 || (_path$21 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 4.5H15A3.75 3.75 0 0 0 12 6a3.75 3.75 0 0 0-3-1.5H2.25a.75.75 0 0 0-.75.75v13.5a.75.75 0 0 0 .75.75H9a2.25 2.25 0 0 1 2.25 2.25.75.75 0 1 0 1.5 0A2.25 2.25 0 0 1 15 19.5h6.75a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75M9 18H3V6h6a2.25 2.25 0 0 1 2.25 2.25v10.5A3.73 3.73 0 0 0 9 18m12 0h-6a3.73 3.73 0 0 0-2.25.75V8.25A2.25 2.25 0 0 1 15 6h6zm-6-9.75h3.75a.75.75 0 1 1 0 1.5H15a.75.75 0 1 1 0-1.5M19.5 12a.75.75 0 0 1-.75.75H15a.75.75 0 1 1 0-1.5h3.75a.75.75 0 0 1 .75.75m0 3a.75.75 0 0 1-.75.75H15a.75.75 0 1 1 0-1.5h3.75a.75.75 0 0 1 .75.75"
	  })));
	};

	var _g$4, _defs$4;
	function _extends$25() { return _extends$25 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$25.apply(null, arguments); }
	var SvgBoyFill = function SvgBoyFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$25({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _g$4 || (_g$4 = /*#__PURE__*/React__namespace.createElement("g", {
	    clipPath: "url(#boy-fill_svg__a)"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M17.785 4.92a1.007 1.007 0 0 1 .026 1.449L14.4 10.017a1.06 1.06 0 0 0-.318.787v9.147a.87.87 0 0 1-.212.586.92.92 0 0 1-.535.308h-.146a.86.86 0 0 1-.62-.268.88.88 0 0 1-.258-.626v-4.349c0-.1-.033-.198-.096-.277a.45.45 0 0 0-.262-.172h-.086a.46.46 0 0 0-.436.273.4.4 0 0 0-.033.176v4.35a.85.85 0 0 1-.217.585.92.92 0 0 1-.505.308h-.151a.86.86 0 0 1-.626-.268.84.84 0 0 1-.267-.626v-9.147a1.05 1.05 0 0 0-.323-.787L5.848 6.394a1.045 1.045 0 0 1 .374-1.692 1 1 0 0 1 .397-.07.98.98 0 0 1 .722.329l2.3 1.922a3.43 3.43 0 0 0 4.375 0l2.301-1.922a.98.98 0 0 1 .727-.328 1 1 0 0 1 .741.287"
	  }), /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M11.902 1.959a2.3 2.3 0 0 1 1.62.7 2.28 2.28 0 0 1 .706 1.62 2.4 2.4 0 0 1-.308 1.262c-.22.378-.536.69-.918.903-.387.22-.827.327-1.272.308a2.32 2.32 0 0 1-1.604-.706 2.37 2.37 0 0 1 .504-3.775 2.35 2.35 0 0 1 1.272-.312"
	  }))), _defs$4 || (_defs$4 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
	    id: "boy-fill_svg__a"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M5 1h13.891v21H5z"
	  })))));
	};

	var _path$20;
	function _extends$24() { return _extends$24 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$24.apply(null, arguments); }
	var SvgBuildingFill = function SvgBuildingFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$24({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$20 || (_path$20 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 21H19.5V3h.75a.75.75 0 1 0 0-1.5H3.75a.75.75 0 0 0 0 1.5h.75v18H2.25a.75.75 0 1 0 0 1.5h19.5a.75.75 0 1 0 0-1.5M8.25 5.25h2.25a.75.75 0 1 1 0 1.5H8.25a.75.75 0 0 1 0-1.5m0 3.75h2.25a.75.75 0 1 1 0 1.5H8.25a.75.75 0 1 1 0-1.5m-.75 4.5a.75.75 0 0 1 .75-.75h2.25a.75.75 0 1 1 0 1.5H8.25a.75.75 0 0 1-.75-.75m6.75 7.5h-4.5v-3.75h4.5zm1.5-6.75H13.5a.75.75 0 1 1 0-1.5h2.25a.75.75 0 1 1 0 1.5m0-3.75H13.5a.75.75 0 1 1 0-1.5h2.25a.75.75 0 1 1 0 1.5m0-3.75H13.5a.75.75 0 1 1 0-1.5h2.25a.75.75 0 1 1 0 1.5"
	  })));
	};

	var _path$1$;
	function _extends$23() { return _extends$23 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$23.apply(null, arguments); }
	var SvgBuilding = function SvgBuilding(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$23({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 21H19.5V3h.75a.75.75 0 1 0 0-1.5H3.75a.75.75 0 0 0 0 1.5h.75v18H2.25a.75.75 0 1 0 0 1.5h19.5a.75.75 0 1 0 0-1.5M6 3h12v18h-3v-3.75a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75V21H6zm7.5 18h-3v-3h3zM8.25 6A.75.75 0 0 1 9 5.25h1.5a.75.75 0 1 1 0 1.5H9A.75.75 0 0 1 8.25 6m4.5 0a.75.75 0 0 1 .75-.75H15a.75.75 0 1 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m-4.5 3.75A.75.75 0 0 1 9 9h1.5a.75.75 0 1 1 0 1.5H9a.75.75 0 0 1-.75-.75m4.5 0A.75.75 0 0 1 13.5 9H15a.75.75 0 1 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75m-4.5 3.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 1 1 0 1.5H9a.75.75 0 0 1-.75-.75m4.5 0a.75.75 0 0 1 .75-.75H15a.75.75 0 1 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75"
	  })));
	};

	var _path$1_;
	function _extends$22() { return _extends$22 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$22.apply(null, arguments); }
	var SvgCalendarDotsFill = function SvgCalendarDotsFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$22({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3M7.875 17.25a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m4.125 0A1.125 1.125 0 1 1 12 15a1.125 1.125 0 0 1 0 2.25m0-3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m4.125 3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m0-3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m3.375-6h-15v-3h2.25v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25z"
	  })));
	};

	var _path$1Z;
	function _extends$21() { return _extends$21 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$21.apply(null, arguments); }
	var SvgCalendarDots = function SvgCalendarDots(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$21({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3M6.75 4.5v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3h-15v-3zm12.75 15h-15V9h15zm-6.375-7.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0M9 16.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m4.125 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
	  })));
	};

	var _path$1Y;
	function _extends$20() { return _extends$20 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$20.apply(null, arguments); }
	var SvgCameraFill = function SvgCameraFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$20({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M19.5 5.25h-2.599l-1.278-1.916A.75.75 0 0 0 15 3H9a.75.75 0 0 0-.623.334L7.097 5.25H4.5A2.25 2.25 0 0 0 2.25 7.5V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V7.5a2.25 2.25 0 0 0-2.25-2.25m-4.125 7.125a3.374 3.374 0 1 1-6.749 0 3.374 3.374 0 0 1 6.749 0"
	  })));
	};

	var _path$1X;
	function _extends$1$() { return _extends$1$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1$.apply(null, arguments); }
	var SvgCamera = function SvgCamera(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1$({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1X || (_path$1X = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M19.5 5.25h-2.599l-1.278-1.916A.75.75 0 0 0 15 3H9a.75.75 0 0 0-.623.334L7.097 5.25H4.5A2.25 2.25 0 0 0 2.25 7.5V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V7.5a2.25 2.25 0 0 0-2.25-2.25M20.25 18a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75V7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 0 .624-.334L9.401 4.5h5.197l1.278 1.916a.75.75 0 0 0 .624.334h3a.75.75 0 0 1 .75.75zM12 8.25a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25M12 15a2.625 2.625 0 1 1 0-5.25A2.625 2.625 0 0 1 12 15"
	  })));
	};

	var _path$1W;
	function _extends$1_() { return _extends$1_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1_.apply(null, arguments); }
	var SvgCaretDown = function SvgCaretDown(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1_({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1W || (_path$1W = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.031 9.53-7.5 7.5a.75.75 0 0 1-1.061 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06L12 15.44l6.969-6.97a.751.751 0 0 1 1.061 1.06Z"
	  })));
	};

	var _path$1V;
	function _extends$1Z() { return _extends$1Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Z.apply(null, arguments); }
	var SvgCaretRight = function SvgCaretRight(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1Z({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1V || (_path$1V = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m17.031 12.53-7.5 7.5a.751.751 0 0 1-1.061-1.06L15.44 12 8.47 5.03a.75.75 0 1 1 1.06-1.06l7.5 7.5a.75.75 0 0 1 0 1.06Z"
	  })));
	};

	var _path$1U;
	function _extends$1Y() { return _extends$1Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Y.apply(null, arguments); }
	var SvgCaretUp = function SvgCaretUp(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1Y({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1U || (_path$1U = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.031 15.53a.747.747 0 0 1-1.061 0L12 8.56l-6.969 6.97a.75.75 0 1 1-1.061-1.06l7.5-7.5a.75.75 0 0 1 1.061 0l7.5 7.5a.747.747 0 0 1 0 1.06"
	  })));
	};

	var _path$1T;
	function _extends$1X() { return _extends$1X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1X.apply(null, arguments); }
	var SvgCaretLeft = function SvgCaretLeft(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1X({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1T || (_path$1T = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M15.53 18.97a.75.75 0 1 1-1.061 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.061 1.06L8.56 12z"
	  })));
	};

	var _path$1S;
	function _extends$1W() { return _extends$1W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1W.apply(null, arguments); }
	var SvgChatFill = function SvgChatFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1W({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1S || (_path$1S = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 6v12a1.5 1.5 0 0 1-1.5 1.5H7.781l-3.056 2.64-.008.007a1.49 1.49 0 0 1-1.604.21A1.49 1.49 0 0 1 2.25 21V6a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5"
	  })));
	};

	var _path$1R;
	function _extends$1V() { return _extends$1V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1V.apply(null, arguments); }
	var SvgCheckCircleFill = function SvgCheckCircleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1V({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1R || (_path$1R = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m4.28 8.03-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.751.751 0 0 1 1.06 1.06"
	  })));
	};

	var _path$1Q;
	function _extends$1U() { return _extends$1U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1U.apply(null, arguments); }
	var SvgCheckCircle = function SvgCheckCircle(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1U({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M16.28 9.22a.75.75 0 0 1 0 1.06l-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 0M21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12m-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12"
	  })));
	};

	var _path$1P;
	function _extends$1T() { return _extends$1T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1T.apply(null, arguments); }
	var SvgCheckSquareFill = function SvgCheckSquareFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1T({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1P || (_path$1P = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3m-3.22 7.28-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.751.751 0 0 1 1.06 1.06"
	  })));
	};

	var _path$1O;
	function _extends$1S() { return _extends$1S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1S.apply(null, arguments); }
	var SvgCheckSquare = function SvgCheckSquare(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1S({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1O || (_path$1O = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M16.28 9.22a.75.75 0 0 1 0 1.06l-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 0M21 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-15A1.5 1.5 0 0 1 4.5 3h15A1.5 1.5 0 0 1 21 4.5m-1.5 15v-15h-15v15z"
	  })));
	};

	var _path$1N;
	function _extends$1R() { return _extends$1R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1R.apply(null, arguments); }
	var SvgCheck = function SvgCheck(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1R({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1N || (_path$1N = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m21.531 7.28-12 12a.75.75 0 0 1-1.061 0l-5.25-5.25a.75.75 0 0 1 1.061-1.06l4.72 4.72L20.47 6.22a.75.75 0 1 1 1.061 1.06"
	  })));
	};

	var _path$1M;
	function _extends$1Q() { return _extends$1Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Q.apply(null, arguments); }
	var SvgClockFill = function SvgClockFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1Q({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1M || (_path$1M = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m5.25 10.5H12a.75.75 0 0 1-.75-.75V6.75a.75.75 0 1 1 1.5 0v4.5h4.5a.75.75 0 1 1 0 1.5"
	  })));
	};

	var _path$1L;
	function _extends$1P() { return _extends$1P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1P.apply(null, arguments); }
	var SvgClock = function SvgClock(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1P({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1L || (_path$1L = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25M18 12a.75.75 0 0 1-.75.75H12a.75.75 0 0 1-.75-.75V6.75a.75.75 0 1 1 1.5 0v4.5h4.5A.75.75 0 0 1 18 12"
	  })));
	};

	var _path$1K;
	function _extends$1O() { return _extends$1O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1O.apply(null, arguments); }
	var SvgCookieFill = function SvgCookieFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1O({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1K || (_path$1K = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 11.25a3.75 3.75 0 0 1-3.75-3.75.75.75 0 0 0-.75-.75A3.75 3.75 0 0 1 12.75 3a.75.75 0 0 0-.75-.75A9.75 9.75 0 1 0 21.75 12a.75.75 0 0 0-.75-.75M7.08 9.33a1.125 1.125 0 1 1 1.587 1.593A1.125 1.125 0 0 1 7.08 9.329Zm2.343 6.843a1.125 1.125 0 1 1 .243-.367q-.087.207-.245.365zm2.156-3.75a1.124 1.124 0 1 1 .365.243 1.1 1.1 0 0 1-.365-.245zm3.844 4.5a1.124 1.124 0 1 1 .243-.367q-.087.207-.245.365z"
	  })));
	};

	var _path$1J;
	function _extends$1N() { return _extends$1N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1N.apply(null, arguments); }
	var SvgCookie = function SvgCookie(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1N({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1J || (_path$1J = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M15.42 15.33a1.125 1.125 0 1 1-1.592 1.587 1.125 1.125 0 0 1 1.593-1.588Zm-7.593-.75a1.125 1.125 0 1 0 .002 0zm.844-3.657a1.125 1.125 0 1 0-.365.243q.206-.087.365-.245zm4.5-.094a1.124 1.124 0 1 0-1.588 1.592 1.124 1.124 0 0 0 1.588-1.592M21.75 12A9.75 9.75 0 1 1 12 2.25a.75.75 0 0 1 .75.75 3.75 3.75 0 0 0 3.75 3.75.75.75 0 0 1 .75.75A3.75 3.75 0 0 0 21 11.25a.75.75 0 0 1 .75.75m-1.53.693a5.26 5.26 0 0 1-4.423-4.49 5.26 5.26 0 0 1-4.49-4.424 8.25 8.25 0 1 0 8.914 8.914Z"
	  })));
	};

	var _path$1I;
	function _extends$1M() { return _extends$1M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1M.apply(null, arguments); }
	var SvgCopySimple = function SvgCopySimple(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1M({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1I || (_path$1I = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M17.25 6H3.75a.75.75 0 0 0-.75.75v13.5a.75.75 0 0 0 .75.75h13.5a.75.75 0 0 0 .75-.75V6.75a.75.75 0 0 0-.75-.75m-.75 13.5h-12v-12h12zM21 3.75v13.5a.75.75 0 1 1-1.5 0V4.5H6.75a.75.75 0 0 1 0-1.5h13.5a.75.75 0 0 1 .75.75"
	  })));
	};

	var _path$1H;
	function _extends$1L() { return _extends$1L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1L.apply(null, arguments); }
	var SvgCreditCardFill = function SvgCreditCardFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1L({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1H || (_path$1H = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5m-8.25 12h-1.5a.75.75 0 1 1 0-1.5h1.5a.75.75 0 1 1 0 1.5m6 0h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 1 1 0 1.5M3 8.25V6h18v2.25z"
	  })));
	};

	var _path$1G;
	function _extends$1K() { return _extends$1K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1K.apply(null, arguments); }
	var SvgCursorFill = function SvgCursorFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1K({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1G || (_path$1G = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.671 19.481-1.19 1.19a1.124 1.124 0 0 1-1.593 0l-5.304-5.303-1.803 4.702-.012.031a1.49 1.49 0 0 1-1.37.9h-.073a1.48 1.48 0 0 1-1.35-1.032L3.075 4.96A1.495 1.495 0 0 1 4.96 3.075l15.008 4.9a1.5 1.5 0 0 1 .132 2.794l-.03.012-4.703 1.807 5.303 5.303a1.125 1.125 0 0 1 0 1.59Z"
	  })));
	};

	var _path$1F;
	function _extends$1J() { return _extends$1J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1J.apply(null, arguments); }
	var SvgCursor = function SvgCursor(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1J({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1F || (_path$1F = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m15.75 12.44 4.32-1.659.031-.012a1.5 1.5 0 0 0-.132-2.794L4.96 3.075a1.495 1.495 0 0 0-1.886 1.886l4.9 15.008A1.48 1.48 0 0 0 9.326 21H9.4a1.49 1.49 0 0 0 1.37-.899l.011-.03 1.659-4.32 4.81 4.81a1.5 1.5 0 0 0 2.122 0l1.189-1.19a1.5 1.5 0 0 0 0-2.12l-4.81-4.811Zm2.56 7.06-4.81-4.81a1.5 1.5 0 0 0-2.437.462c0 .01-.009.02-.013.03l-1.654 4.312L4.5 4.5l14.986 4.894-4.308 1.654-.03.012a1.5 1.5 0 0 0-.462 2.437l4.814 4.814-1.19 1.19Z"
	  })));
	};

	var _path$1E;
	function _extends$1I() { return _extends$1I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1I.apply(null, arguments); }
	var SvgDotsThreeOutlineFill = function SvgDotsThreeOutlineFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1I({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1E || (_path$1E = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M14.625 12a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0M4.5 9.375a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25m15 0a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25"
	  })));
	};

	var _path$1D;
	function _extends$1H() { return _extends$1H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1H.apply(null, arguments); }
	var SvgDotsThreeOutline = function SvgDotsThreeOutline(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1H({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1D || (_path$1D = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M4.5 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m15-4.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
	  })));
	};

	var _path$1C;
	function _extends$1G() { return _extends$1G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1G.apply(null, arguments); }
	var SvgDownloadSimple = function SvgDownloadSimple(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1G({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1C || (_path$1C = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 13.5v6a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 19.5v-6a.75.75 0 1 1 1.5 0v5.25h15V13.5a.75.75 0 1 1 1.5 0m-9.53.53a.747.747 0 0 0 1.06 0l3.75-3.75a.75.75 0 1 0-1.06-1.06l-2.47 2.47V3a.75.75 0 1 0-1.5 0v8.69L8.78 9.22a.75.75 0 0 0-1.06 1.06z"
	  })));
	};

	var _path$1B;
	function _extends$1F() { return _extends$1F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1F.apply(null, arguments); }
	var SvgEnvelopeSimpleFill = function SvgEnvelopeSimpleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1F({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1B || (_path$1B = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 4.5H3a.75.75 0 0 0-.75.75V18a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25A.75.75 0 0 0 21 4.5M20.25 18H3.75V6.955l7.743 7.098a.75.75 0 0 0 1.014 0l7.743-7.098z"
	  })));
	};

	var _path$1A;
	function _extends$1E() { return _extends$1E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1E.apply(null, arguments); }
	var SvgEnvelopeSimple = function SvgEnvelopeSimple(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1E({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1A || (_path$1A = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 4.5H3a.75.75 0 0 0-.75.75V18a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25A.75.75 0 0 0 21 4.5m-9 7.983L4.928 6h14.144zM9.254 12 3.75 17.045V6.955zm1.11 1.017 1.125 1.036a.75.75 0 0 0 1.014 0l1.125-1.036L19.066 18H4.928zM14.746 12l5.504-5.046v10.092z"
	  })));
	};

	var _path$1z;
	function _extends$1D() { return _extends$1D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1D.apply(null, arguments); }
	var SvgEyeFill = function SvgEyeFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1D({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1z || (_path$1z = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M23.185 11.696c-.032-.074-.827-1.835-2.592-3.6C18.241 5.742 15.27 4.5 12 4.5S5.76 5.743 3.407 8.095C1.642 9.861.844 11.625.815 11.696a.75.75 0 0 0 0 .61c.032.074.827 1.834 2.592 3.6C5.759 18.256 8.73 19.5 12 19.5s6.24-1.243 8.593-3.594c1.765-1.766 2.56-3.526 2.592-3.6a.75.75 0 0 0 0-.61M12 15.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5"
	  })));
	};

	var _path$1y, _path2$3;
	function _extends$1C() { return _extends$1C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1C.apply(null, arguments); }
	var SvgEyeSlashFill = function SvgEyeSlashFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1C({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1y || (_path$1y = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "m5.843 4.113-.788-.868a.75.75 0 0 0-1.11 1.01L5.75 6.24c-.834.51-1.618 1.13-2.343 1.855C1.642 9.861.844 11.625.815 11.696a.75.75 0 0 0 0 .61c.032.074.827 1.834 2.592 3.6C5.759 18.256 8.73 19.5 12 19.5c1.725 0 3.367-.346 4.879-1.018l2.066 2.273a.75.75 0 0 0 1.212-.868L5.945 4.255a1 1 0 0 1-.102-.142m2.48 7.155a3.75 3.75 0 0 1 .65-1.482l4.944 5.437a3.75 3.75 0 0 1-5.595-3.955Z",
	    clipRule: "evenodd"
	  })), _path2$3 || (_path2$3 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M19.473 16.905q.58-.46 1.12-1c1.765-1.765 2.56-3.525 2.592-3.6a.75.75 0 0 0 0-.609c-.032-.074-.827-1.835-2.592-3.6C18.241 5.742 15.27 4.5 12 4.5c-1.169 0-2.3.159-3.377.47l2.999 3.3a3.75 3.75 0 0 1 4.056 4.46z"
	  })));
	};

	var _path$1x;
	function _extends$1B() { return _extends$1B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1B.apply(null, arguments); }
	var SvgEyeSlash = function SvgEyeSlash(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1B({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1x || (_path$1x = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M3.995 3.195a.75.75 0 0 1 1.06.05l2.425 2.67.022.025 2.52 2.77.02.023 5.021 5.524.027.03 2.515 2.766.022.024 2.427 2.67a.75.75 0 1 1-1.11 1.009l-2.064-2.27a11.8 11.8 0 0 1-4.884 1.015c-3.998 0-6.803-1.807-8.59-3.595a14.2 14.2 0 0 1-1.956-2.45A12 12 0 0 1 .86 12.4l-.032-.067-.009-.02-.003-.006v-.002L1.5 12l-.685-.305v-.002l.002-.004.006-.011.018-.039.065-.135c.057-.114.142-.275.254-.473.225-.396.565-.94 1.03-1.546.793-1.034 1.96-2.266 3.558-3.247L3.945 4.255a.75.75 0 0 1 .05-1.06M6.778 7.37c-1.525.88-2.641 2.041-3.397 3.028A12 12 0 0 0 2.338 12c.089.165.215.39.382.655.376.597.952 1.394 1.748 2.19C6.055 16.432 8.499 18 12 18h.006c1.303.01 2.593-.227 3.803-.695l-1.379-1.517a4.501 4.501 0 0 1-5.97-6.567l-1.682-1.85Zm2.713 2.985a3 3 0 0 0 3.908 4.3zM1.5 12l-.685-.305a.75.75 0 0 0 0 .61zm8.44-7.332A12.6 12.6 0 0 1 12 4.5c4 0 6.805 1.807 8.593 3.595a14.2 14.2 0 0 1 1.956 2.45 12 12 0 0 1 .591 1.054l.032.067.009.02.003.006v.002s.001.001-.684.306l.685.305-.002.004-.003.007-.01.023-.038.079a13 13 0 0 1-.71 1.233 14 14 0 0 1-2.365 2.76.75.75 0 0 1-1-1.117 12.6 12.6 0 0 0 2.11-2.464c.224-.342.387-.63.494-.83-.088-.165-.215-.39-.382-.655a12.7 12.7 0 0 0-1.747-2.19C17.945 7.568 15.501 6 12 6h-.001q-.914 0-1.816.147a.75.75 0 1 1-.244-1.48ZM22.5 12l.685.305a.75.75 0 0 0 0-.61zM11.97 8.176a.75.75 0 0 1 .877-.596 4.5 4.5 0 0 1 3.634 3.997.75.75 0 1 1-1.494.14 3 3 0 0 0-2.422-2.664.75.75 0 0 1-.596-.877Z",
	    clipRule: "evenodd"
	  })));
	};

	var _path$1w;
	function _extends$1A() { return _extends$1A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1A.apply(null, arguments); }
	var SvgEye = function SvgEye(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1A({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1w || (_path$1w = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M23.185 11.696c-.032-.074-.827-1.835-2.592-3.6C18.241 5.742 15.27 4.5 12 4.5S5.76 5.743 3.407 8.095C1.642 9.861.844 11.625.815 11.696a.75.75 0 0 0 0 .61c.032.074.827 1.834 2.592 3.6C5.759 18.256 8.73 19.5 12 19.5s6.24-1.243 8.593-3.594c1.765-1.766 2.56-3.526 2.592-3.6a.75.75 0 0 0 0-.61M12 18c-2.886 0-5.407-1.05-7.493-3.117A12.5 12.5 0 0 1 2.344 12a12.5 12.5 0 0 1 2.163-2.883C6.593 7.05 9.114 6 12 6s5.407 1.05 7.493 3.117A12.5 12.5 0 0 1 21.661 12c-.676 1.262-3.62 6-9.661 6m0-10.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 7.5a3 3 0 1 1 0-5.999A3 3 0 0 1 12 15"
	  })));
	};

	var _path$1v;
	function _extends$1z() { return _extends$1z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1z.apply(null, arguments); }
	var SvgFacebookLogoFill = function SvgFacebookLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1z({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1v || (_path$1v = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 12a9.765 9.765 0 0 1-8.583 9.68.375.375 0 0 1-.417-.375V14.25H15a.75.75 0 0 0 .75-.8.766.766 0 0 0-.774-.7H12.75V10.5a1.5 1.5 0 0 1 1.5-1.5h1.5a.75.75 0 0 0 .75-.8.766.766 0 0 0-.775-.7H14.25a3 3 0 0 0-3 3v2.25H9a.75.75 0 0 0-.75.8.766.766 0 0 0 .775.7h2.225v7.057a.375.375 0 0 1-.416.375 9.764 9.764 0 0 1-8.577-10.049c.187-5.062 4.288-9.178 9.354-9.375A9.76 9.76 0 0 1 21.75 12"
	  })));
	};

	var _path$1u;
	function _extends$1y() { return _extends$1y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1y.apply(null, arguments); }
	var SvgFacebookLogo = function SvgFacebookLogo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1y({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1u || (_path$1u = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m.75 17.965V14.25H15a.75.75 0 1 0 0-1.5h-2.25V10.5a1.5 1.5 0 0 1 1.5-1.5h1.5a.75.75 0 1 0 0-1.5h-1.5a3 3 0 0 0-3 3v2.25H9a.75.75 0 1 0 0 1.5h2.25v5.965a8.25 8.25 0 1 1 1.5 0"
	  })));
	};

	var _path$1t;
	function _extends$1x() { return _extends$1x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1x.apply(null, arguments); }
	var SvgFemaleFill = function SvgFemaleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1x({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1t || (_path$1t = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M13.777 2.223Q13.055 1.499 12 1.5q-1.055 0-1.777.723Q9.499 2.945 9.5 4q0 1.055.723 1.777.722.723 1.777.723t1.777-.723Q14.5 5.055 14.5 4t-.723-1.777m2.715 13.925q.274-.35.156-.82l-1.875-7.5a.9.9 0 0 0-.332-.508.9.9 0 0 0-.566-.195h-.43q-.703.312-1.445.312t-1.445-.312h-.43a.9.9 0 0 0-.566.195q-.255.196-.332.508l-1.875 7.5q-.118.47.156.82a.89.89 0 0 0 .742.352h2.188v4.063q0 .39.273.664a.9.9 0 0 0 .664.273h1.25q.39 0 .664-.273a.9.9 0 0 0 .274-.665V16.5h2.187a.89.89 0 0 0 .742-.352",
	    clipRule: "evenodd"
	  })));
	};

	var _path$1s;
	function _extends$1w() { return _extends$1w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1w.apply(null, arguments); }
	var SvgFileFill = function SvgFileFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1w({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1s || (_path$1s = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.03 7.72-5.25-5.25a.75.75 0 0 0-.53-.22h-9a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-12a.75.75 0 0 0-.22-.53m-5.78.53V4.125l4.125 4.125z"
	  })));
	};

	var _path$1r;
	function _extends$1v() { return _extends$1v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1v.apply(null, arguments); }
	var SvgFile = function SvgFile(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1v({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1r || (_path$1r = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.03 7.72-5.25-5.25a.75.75 0 0 0-.53-.22h-9a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-12a.75.75 0 0 0-.22-.53M15 4.81l2.69 2.69H15zm3.75 15.44H5.25V3.75h8.25v4.5a.75.75 0 0 0 .75.75h4.5z"
	  })));
	};

	var _path$1q;
	function _extends$1u() { return _extends$1u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1u.apply(null, arguments); }
	var SvgGiftFill = function SvgGiftFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1u({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1q || (_path$1q = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.25 6.75h-3.289q.056-.045.11-.094A2.77 2.77 0 0 0 18 4.647 3.057 3.057 0 0 0 14.854 1.5a2.77 2.77 0 0 0-2.01.929A5.2 5.2 0 0 0 12 3.787a5.2 5.2 0 0 0-.844-1.358 2.77 2.77 0 0 0-2.01-.929A3.06 3.06 0 0 0 6 4.647a2.77 2.77 0 0 0 .93 2.01l.109.093H3.75a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h5.625a.375.375 0 0 0 .375-.375V11.25h-7.5v-3h7.5v3h1.5v-3h7.5v3h-7.5v8.625a.375.375 0 0 0 .375.375h5.625a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5M7.923 5.531a1.28 1.28 0 0 1-.422-.937A1.56 1.56 0 0 1 9.055 3h.046a1.28 1.28 0 0 1 .938.422c.786.889 1.064 2.362 1.161 3.274-.915-.097-2.387-.374-3.277-1.165m8.156 0c-.89.788-2.366 1.065-3.281 1.163.111-.986.42-2.428 1.17-3.271A1.28 1.28 0 0 1 14.907 3h.046A1.56 1.56 0 0 1 16.5 4.6a1.3 1.3 0 0 1-.423.93h.002Z"
	  })));
	};

	var _path$1p;
	function _extends$1t() { return _extends$1t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1t.apply(null, arguments); }
	var SvgGift = function SvgGift(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1t({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1p || (_path$1p = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.25 6.75h-3.289q.056-.045.11-.094A2.77 2.77 0 0 0 18 4.647 3.057 3.057 0 0 0 14.854 1.5a2.77 2.77 0 0 0-2.01.929A5.2 5.2 0 0 0 12 3.787a5.2 5.2 0 0 0-.844-1.358 2.77 2.77 0 0 0-2.01-.929A3.06 3.06 0 0 0 6 4.647a2.77 2.77 0 0 0 .93 2.01l.109.093H3.75a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5v6a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5m-6.281-3.327A1.28 1.28 0 0 1 14.906 3h.046A1.56 1.56 0 0 1 16.5 4.6a1.28 1.28 0 0 1-.422.938c-.89.787-2.366 1.065-3.281 1.162.112-.993.422-2.435 1.172-3.278Zm-6.009.034A1.56 1.56 0 0 1 9.055 3h.046a1.28 1.28 0 0 1 .938.422c.786.889 1.064 2.362 1.161 3.274-.91-.094-2.385-.375-3.273-1.162a1.28 1.28 0 0 1-.422-.937 1.56 1.56 0 0 1 .452-1.14zM3.75 8.25h7.5v3h-7.5zm1.5 4.5h6v6h-6zm13.5 6h-6v-6h6zm1.5-7.5h-7.5v-3h7.5z"
	  })));
	};

	var _g$3, _defs$3;
	function _extends$1s() { return _extends$1s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1s.apply(null, arguments); }
	var SvgGirlFill = function SvgGirlFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1s({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _g$3 || (_g$3 = /*#__PURE__*/React__namespace.createElement("g", {
	    clipPath: "url(#girl-fill_svg__a)"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m17.9 6.755.123.103a.9.9 0 0 1 .319.695.98.98 0 0 1-.28.735l-2.336 2.448a1.6 1.6 0 0 0-.382.69 1.56 1.56 0 0 0 0 .819l1.117 4.55a.94.94 0 0 1-.176.866.98.98 0 0 1-.799.382H13.68v2.836c.012.347-.107.686-.333.95a1.43 1.43 0 0 1-.891.49h-.186a1.4 1.4 0 0 1-1.024-.421 1.37 1.37 0 0 1-.426-.98v-2.865H9.002a.98.98 0 0 1-.95-1.244l1.117-4.535c.07-.268.07-.55 0-.818a1.54 1.54 0 0 0-.407-.69L6.446 8.317a.98.98 0 0 1-.299-.67.94.94 0 0 1 .206-.662l.137-.127a.98.98 0 0 1 .715-.28.98.98 0 0 1 .7.309l2.214 1.861a3.27 3.27 0 0 0 3.257.578c.358-.133.69-.328.98-.578l2.237-1.861c.169-.174.392-.285.632-.313.24-.023.48.042.676.18ZM8.028 2.122a2.66 2.66 0 0 1 1.758.95q.28.39.519.808l.103.186a.16.16 0 0 1 .037.182.2.2 0 0 1-.037.053.21.21 0 0 1-.27.035 6.4 6.4 0 0 0-.867-.353 2.4 2.4 0 0 0-.89-.132 5.2 5.2 0 0 0-1.117.171.22.22 0 0 1-.177-.03.14.14 0 0 1-.049-.156L7.41 2.43a.4.4 0 0 1 .196-.269.9.9 0 0 1 .422-.04Z"
	  }), /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12.313 3.983a2.2 2.2 0 0 1 1.582.68 2.316 2.316 0 0 1 .392 2.807 2.3 2.3 0 0 1-.887.886 2.35 2.35 0 0 1-1.234.299 2.33 2.33 0 0 1-1.572-.69 2.2 2.2 0 0 1-.676-1.568 2.24 2.24 0 0 1 .294-1.234 2.4 2.4 0 0 1 .882-.881c.37-.212.793-.316 1.22-.3Zm4.78-1.553.352 1.406a.17.17 0 0 1-.044.157.17.17 0 0 1-.166.054 4.4 4.4 0 0 0-1.117-.196 2.3 2.3 0 0 0-.867.132q-.451.15-.872.372a.21.21 0 0 1-.269-.039q-.118-.126-.04-.23l.065-.103q.246-.438.538-.847c.197-.255.434-.476.7-.657a2.8 2.8 0 0 1 1.098-.352q.216-.01.426.049a.38.38 0 0 1 .196.254"
	  }))), _defs$3 || (_defs$3 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
	    id: "girl-fill_svg__a"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M6 1.5h12.596v21H6z"
	  })))));
	};

	var _path$1o;
	function _extends$1r() { return _extends$1r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1r.apply(null, arguments); }
	var SvgGlobe = function SvgGlobe(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1r({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1o || (_path$1o = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25M20.25 12a8.2 8.2 0 0 1-.312 2.25h-3.61a14.8 14.8 0 0 0 0-4.5h3.61A8.2 8.2 0 0 1 20.25 12M9.562 15.75h4.876A10.8 10.8 0 0 1 12 19.969a10.8 10.8 0 0 1-2.438-4.219m-.365-1.5a13.2 13.2 0 0 1 0-4.5h5.614a13.2 13.2 0 0 1 0 4.5zM3.75 12c0-.76.104-1.518.312-2.25h3.61a14.8 14.8 0 0 0 0 4.5h-3.61A8.2 8.2 0 0 1 3.75 12m10.688-3.75H9.561A10.8 10.8 0 0 1 12 4.031a10.8 10.8 0 0 1 2.438 4.219m4.905 0h-3.339a12.7 12.7 0 0 0-2.09-4.275 8.28 8.28 0 0 1 5.433 4.275zm-9.256-4.275c-.96 1.28-1.67 2.73-2.091 4.275H4.653a8.28 8.28 0 0 1 5.434-4.275M4.653 15.75h3.343a12.7 12.7 0 0 0 2.09 4.275 8.28 8.28 0 0 1-5.433-4.275m9.26 4.275c.96-1.28 1.67-2.73 2.091-4.275h3.343a8.28 8.28 0 0 1-5.434 4.275"
	  })));
	};

	var _path$1n;
	function _extends$1q() { return _extends$1q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1q.apply(null, arguments); }
	var SvgHeartFill = function SvgHeartFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1q({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1n || (_path$1n = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.5 9.563c0 6.562-9.73 11.874-10.145 12.093a.75.75 0 0 1-.71 0C11.23 21.436 1.5 16.125 1.5 9.563A5.82 5.82 0 0 1 7.313 3.75c1.935 0 3.63.832 4.687 2.24 1.057-1.408 2.752-2.24 4.688-2.24A5.82 5.82 0 0 1 22.5 9.563"
	  })));
	};

	var _path$1m;
	function _extends$1p() { return _extends$1p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1p.apply(null, arguments); }
	var SvgHeart = function SvgHeart(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1p({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1m || (_path$1m = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M16.688 3.75c-1.936 0-3.631.832-4.688 2.24-1.057-1.408-2.752-2.24-4.688-2.24A5.82 5.82 0 0 0 1.5 9.563c0 6.562 9.73 11.874 10.145 12.093a.75.75 0 0 0 .71 0c.415-.22 10.145-5.531 10.145-12.093a5.82 5.82 0 0 0-5.813-5.813ZM12 20.137c-1.712-.997-9-5.541-9-10.575A4.32 4.32 0 0 1 7.313 5.25c1.823 0 3.354.971 3.993 2.531a.75.75 0 0 0 1.388 0c.64-1.563 2.17-2.531 3.993-2.531A4.32 4.32 0 0 1 21 9.563c0 5.025-7.29 9.576-9 10.574"
	  })));
	};

	var _path$1l;
	function _extends$1o() { return _extends$1o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1o.apply(null, arguments); }
	var SvgHouseFill = function SvgHouseFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1o({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1l || (_path$1l = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 11.25v9a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75v-4.875a.375.375 0 0 0-.375-.375h-3.75a.375.375 0 0 0-.375.375v4.875A.75.75 0 0 1 9 21H3.75a.75.75 0 0 1-.75-.75v-9c0-.398.158-.78.44-1.06l7.5-7.5a1.5 1.5 0 0 1 2.12 0l7.5 7.5a1.5 1.5 0 0 1 .44 1.06"
	  })));
	};

	var _path$1k;
	function _extends$1n() { return _extends$1n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1n.apply(null, arguments); }
	var SvgHouse = function SvgHouse(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1n({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1k || (_path$1k = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.56 10.189-7.5-7.5a1.5 1.5 0 0 0-2.12 0l-7.5 7.5A1.5 1.5 0 0 0 3 11.25v9a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75V15h3v5.25a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75v-9a1.5 1.5 0 0 0-.44-1.061M19.5 19.5H15v-5.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75v5.25H4.5v-8.25l7.5-7.5 7.5 7.5z"
	  })));
	};

	var _path$1j;
	function _extends$1m() { return _extends$1m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1m.apply(null, arguments); }
	var SvgImageFill = function SvgImageFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1m({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1j || (_path$1j = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5m-5.625 4.5a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m5.625 10.5H3.75v-3.685l4.344-4.346a.75.75 0 0 1 1.062 0l6.313 6.312a.75.75 0 1 0 1.061-1.062l-1.656-1.654 1.345-1.346a.75.75 0 0 1 1.06 0l2.971 2.975z"
	  })));
	};

	var _path$1i;
	function _extends$1l() { return _extends$1l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1l.apply(null, arguments); }
	var SvgImage = function SvgImage(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1l({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1i || (_path$1i = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5m0 1.5v9.633l-2.444-2.443a1.5 1.5 0 0 0-2.122 0l-1.875 1.875-4.125-4.125a1.5 1.5 0 0 0-2.12 0L3.75 14.003V5.25zM3.75 16.125l4.875-4.875 7.5 7.5H3.75zm16.5 2.625h-2.003l-3.375-3.375 1.875-1.875 3.503 3.504zM13.5 9.375a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0"
	  })));
	};

	var _path$1h;
	function _extends$1k() { return _extends$1k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1k.apply(null, arguments); }
	var SvgInfoFill = function SvgInfoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1k({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1h || (_path$1h = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m-.375 4.5a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m1.125 10.5a1.5 1.5 0 0 1-1.5-1.5V12a.75.75 0 1 1 0-1.5 1.5 1.5 0 0 1 1.5 1.5v3.75a.75.75 0 1 1 0 1.5"
	  })));
	};

	var _path$1g;
	function _extends$1j() { return _extends$1j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1j.apply(null, arguments); }
	var SvgInfo = function SvgInfo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1j({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1g || (_path$1g = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25m1.5-3.75a.75.75 0 0 1-.75.75 1.5 1.5 0 0 1-1.5-1.5V12a.75.75 0 1 1 0-1.5 1.5 1.5 0 0 1 1.5 1.5v3.75a.75.75 0 0 1 .75.75m-3-8.625a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0"
	  })));
	};

	var _path$1f;
	function _extends$1i() { return _extends$1i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1i.apply(null, arguments); }
	var SvgInstagramLogoFill = function SvgInstagramLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1i({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1f || (_path$1f = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M16.5 2.25h-9A5.256 5.256 0 0 0 2.25 7.5v9a5.256 5.256 0 0 0 5.25 5.25h9a5.256 5.256 0 0 0 5.25-5.25v-9a5.256 5.256 0 0 0-5.25-5.25M12 16.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m5.625-9a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25M15 12a3 3 0 1 1-5.999 0A3 3 0 0 1 15 12"
	  })));
	};

	var _path$1e;
	function _extends$1h() { return _extends$1h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1h.apply(null, arguments); }
	var SvgInstagramLogo = function SvgInstagramLogo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1h({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1e || (_path$1e = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 7.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m0 7.5a3 3 0 1 1 0-5.999A3 3 0 0 1 12 15m4.5-12.75h-9A5.256 5.256 0 0 0 2.25 7.5v9a5.256 5.256 0 0 0 5.25 5.25h9a5.256 5.256 0 0 0 5.25-5.25v-9a5.256 5.256 0 0 0-5.25-5.25m3.75 14.25a3.75 3.75 0 0 1-3.75 3.75h-9a3.75 3.75 0 0 1-3.75-3.75v-9A3.75 3.75 0 0 1 7.5 3.75h9a3.75 3.75 0 0 1 3.75 3.75zM18 7.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
	  })));
	};

	var _path$1d;
	function _extends$1g() { return _extends$1g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1g.apply(null, arguments); }
	var SvgJuniorFill = function SvgJuniorFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1g({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1d || (_path$1d = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m11.206 6.835.105.085a.75.75 0 0 1 .263.58.84.84 0 0 1-.23.602l-1.93 2.023a1.32 1.32 0 0 0-.32 1.25l.898 3.768a.81.81 0 0 1-.81 1.027H7.719v2.343c.003.286-.1.562-.287.777-.188.22-.45.365-.737.405h-.153a1.14 1.14 0 0 1-.846-.352 1.13 1.13 0 0 1-.352-.81V16.17h-1.49a.78.78 0 0 1-.639-.315.78.78 0 0 1-.145-.712l.922-3.76c.061-.22.061-.454 0-.675a1.3 1.3 0 0 0-.331-.575L1.746 8.11a.78.78 0 0 1-.243-.526.8.8 0 0 1 .166-.562l.1-.102a.8.8 0 0 1 .592-.23.8.8 0 0 1 .59.263l1.83 1.542a2.68 2.68 0 0 0 2.69.477c.296-.111.57-.273.81-.477l1.845-1.542a.9.9 0 0 1 .526-.263.8.8 0 0 1 .554.145M3.053 3.004c.306.037.602.136.87.29.223.129.42.298.582.499q.154.206.43.667l.1.154a.14.14 0 0 1-.032.194.174.174 0 0 1-.223.029 5 5 0 0 0-.72-.292 2 2 0 0 0-.716-.113q-.468.026-.923.146a.17.17 0 0 1-.145-.025.12.12 0 0 1-.045-.13l.308-1.16a.34.34 0 0 1 .17-.215.8.8 0 0 1 .344-.044m3.536 1.541a1.84 1.84 0 0 1 1.311.563 1.93 1.93 0 0 1 .324 2.318 1.9 1.9 0 0 1-.737.733 1.91 1.91 0 0 1-2.314-.324 1.83 1.83 0 0 1-.567-1.307 1.94 1.94 0 0 1 .976-1.736 1.85 1.85 0 0 1 1.007-.247m3.95-1.282.29 1.16a.14.14 0 0 1-.095.17.13.13 0 0 1-.074 0q-.452-.134-.923-.161a2 2 0 0 0-.72.113 4.5 4.5 0 0 0-.716.308.17.17 0 0 1-.223-.037q-.104-.102-.032-.186l.048-.085a9 9 0 0 1 .445-.704c.166-.21.362-.395.583-.546.28-.156.588-.255.906-.291q.189-.012.369.044a.3.3 0 0 1 .141.215Zm11.714 3.641a.8.8 0 0 1 .246.595.78.78 0 0 1-.23.587l-2.736 2.925a.86.86 0 0 0-.259.632v7.331a.7.7 0 0 1-.17.47.74.74 0 0 1-.424.247h-.122a.7.7 0 0 1-.514-.215.7.7 0 0 1-.202-.502v-3.487a.4.4 0 0 0-.077-.223.4.4 0 0 0-.214-.137h-.07a.38.38 0 0 0-.266.1.34.34 0 0 0-.11.26v3.487a.7.7 0 0 1-.17.47.76.76 0 0 1-.428.247h-.122a.73.73 0 0 1-.728-.716v-7.337a.86.86 0 0 0-.255-.63l-2.735-2.91a.834.834 0 0 1 .944-1.338q.151.069.261.193l1.85 1.542a2.75 2.75 0 0 0 3.504 0l1.845-1.542a.78.78 0 0 1 .583-.263.84.84 0 0 1 .599.23zM17.53 4.545a1.922 1.922 0 0 1 .64 3.713 1.9 1.9 0 0 1-.773.131 1.87 1.87 0 0 1-1.29-.57 1.894 1.894 0 0 1-.329-2.299 1.93 1.93 0 0 1 .737-.728c.308-.176.66-.261 1.015-.247"
	  })));
	};

	var _path$1c, _path2$2;
	function _extends$1f() { return _extends$1f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1f.apply(null, arguments); }
	var SvgKlarnaLogoFill = function SvgKlarnaLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1f({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1c || (_path$1c = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M18.477 12.478c.415 0 .752.322.752.72s-.337.72-.752.72c-.416 0-.753-.322-.753-.72s.337-.72.753-.72m-8.76 0c.415 0 .752.322.752.72s-.337.72-.752.72c-.416 0-.753-.322-.753-.72s.337-.72.753-.72"
	  })), _path2$2 || (_path2$2 = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M3.112 6.444h17.775c1.167 0 2.113.946 2.113 2.113v7.997a2.113 2.113 0 0 1-2.113 2.113H3.113A2.11 2.11 0 0 1 1 16.554V8.557c0-1.167.946-2.113 2.112-2.113m17.31 7.686c0-.29.234-.526.522-.526s.521.236.521.526-.233.526-.521.526a.524.524 0 0 1-.521-.526Zm-.36-2.331h-.83v.179a1.45 1.45 0 0 0-.823-.257 1.47 1.47 0 0 0-1.464 1.477 1.47 1.47 0 0 0 1.464 1.477c.305 0 .588-.095.823-.257v.18h.83zm-7.475 0v.364c.166-.219.477-.364.814-.364v.814h-.01c-.329 0-.802.237-.802.678v1.306h-.852V11.8h.85Zm-1.285 0h-.83v.179a1.45 1.45 0 0 0-.823-.257 1.47 1.47 0 0 0-1.463 1.477 1.47 1.47 0 0 0 1.463 1.477c.305 0 .589-.095.823-.257v.18h.83zm3.312.315c.21-.287.524-.39.856-.39.669 0 1.182.442 1.182 1.094v1.78h-.83V13.12c0-.408-.21-.628-.574-.628-.34 0-.623.208-.623.633v1.471h-.837V11.8h.826zm-6.769 2.483h-.869v-4.045h.87zm-3.767.001h-.92v-4.047h.92zm1.358-1.75a3.23 3.23 0 0 0 .941-2.297h-.9c0 .745-.34 1.428-.932 1.876l-.356.27 1.382 1.901h1.137z",
	    clipRule: "evenodd"
	  })));
	};

	var _path$1b;
	function _extends$1e() { return _extends$1e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1e.apply(null, arguments); }
	var SvgLeafFill = function SvgLeafFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1e({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1b || (_path$1b = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M13.199 7.267c-3.345 2.086-2.46 5.287-2.46 5.287s-.977 1.427-1.387 3.181l-.004.011a8.3 8.3 0 0 0-1.068-2.445c.403-.66-.105-2.438-1.476-3.288C4.137 8.36 1 9.917 1 9.917s1.894 2.755 3.53 3.487c1.387.621 1.948.258 1.948.258s-.838-2.008-3.091-2.912c.438.003 1.072.12 1.494.214.345.077 2.02.753 2.843 2.34a7.8 7.8 0 0 1 .885 2.226c.102.45.164.906.17 1.355.004.126.015.62-.048 1.115h1.464c-.043-1.26.18-2.6.272-2.916.102-.347 1.092-3.676 3.103-5.38 2.053-1.74 5.383-2.14 6.063-2.184-5.995 1.889-6.594 5.504-6.594 5.504s2.76-.03 5.106-1.556C20.81 9.736 23 7.646 23 7.646s-4.9-3.436-9.801-.38Z"
	  })));
	};

	var _path$1a;
	function _extends$1d() { return _extends$1d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1d.apply(null, arguments); }
	var SvgLightbulbFill = function SvgLightbulbFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1d({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1a || (_path$1a = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M16.5 21.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1 0-1.5h7.5a.75.75 0 0 1 .75.75m3.75-12a8.2 8.2 0 0 1-3.154 6.488 1.52 1.52 0 0 0-.596 1.2V18a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 18v-.563a1.5 1.5 0 0 0-.584-1.186A8.21 8.21 0 0 1 3.75 9.796c-.024-4.468 3.587-8.19 8.051-8.296a8.25 8.25 0 0 1 8.45 8.25Zm-3.01-.876a5.4 5.4 0 0 0-4.365-4.364.75.75 0 1 0-.25 1.48c1.554.261 2.872 1.58 3.135 3.136a.75.75 0 0 0 1.48-.252"
	  })));
	};

	var _path$19;
	function _extends$1c() { return _extends$1c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1c.apply(null, arguments); }
	var SvgLightbulb = function SvgLightbulb(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1c({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$19 || (_path$19 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M16.5 21.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1 0-1.5h7.5a.75.75 0 0 1 .75.75m3.75-12a8.2 8.2 0 0 1-3.154 6.488 1.52 1.52 0 0 0-.596 1.2V18a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 18v-.563a1.5 1.5 0 0 0-.584-1.186A8.21 8.21 0 0 1 3.75 9.796c-.024-4.468 3.587-8.19 8.051-8.296a8.25 8.25 0 0 1 8.45 8.25Zm-1.5 0A6.75 6.75 0 0 0 11.837 3C8.181 3.086 5.23 6.13 5.25 9.787a6.72 6.72 0 0 0 2.591 5.278 3 3 0 0 1 1.16 2.373V18h6v-.563a3.02 3.02 0 0 1 1.168-2.376A6.72 6.72 0 0 0 18.75 9.75m-1.51-.876a5.4 5.4 0 0 0-4.365-4.364.75.75 0 1 0-.25 1.48c1.554.261 2.872 1.58 3.135 3.136a.75.75 0 0 0 1.48-.252"
	  })));
	};

	var _path$18;
	function _extends$1b() { return _extends$1b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1b.apply(null, arguments); }
	var SvgLinkedinLogoFill = function SvgLinkedinLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1b({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$18 || (_path$18 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.25 2.25H3.75a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5M9 16.5a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0zM8.25 9a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25m9 7.5a.75.75 0 1 1-1.5 0v-3.375a1.875 1.875 0 1 0-3.75 0V16.5a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.48-.167 3.375 3.375 0 0 1 5.27 2.792z"
	  })));
	};

	var _path$17;
	function _extends$1a() { return _extends$1a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1a.apply(null, arguments); }
	var SvgLinkedinLogo = function SvgLinkedinLogo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1a({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$17 || (_path$17 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.25 2.25H3.75a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5m0 18H3.75V3.75h16.5zM9 10.5v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0m8.25 2.625V16.5a.75.75 0 1 1-1.5 0v-3.375a1.875 1.875 0 1 0-3.75 0V16.5a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.48-.167 3.375 3.375 0 0 1 5.27 2.792m-7.875-5.25a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
	  })));
	};

	var _path$16;
	function _extends$19() { return _extends$19 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$19.apply(null, arguments); }
	var SvgListBullets = function SvgListBullets(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$19({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$16 || (_path$16 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M7.5 6a.75.75 0 0 1 .75-.75h12a.75.75 0 1 1 0 1.5h-12A.75.75 0 0 1 7.5 6m12.75 5.25h-12a.75.75 0 1 0 0 1.5h12a.75.75 0 1 0 0-1.5m0 6h-12a.75.75 0 1 0 0 1.5h12a.75.75 0 1 0 0-1.5M4.125 4.875a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25m0 6a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25m0 6a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25"
	  })));
	};

	var _path$15;
	function _extends$18() { return _extends$18 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$18.apply(null, arguments); }
	var SvgList = function SvgList(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$18({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$15 || (_path$15 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 12a.75.75 0 0 1-.75.75H3.75a.75.75 0 1 1 0-1.5h16.5A.75.75 0 0 1 21 12M3.75 6.75h16.5a.75.75 0 1 0 0-1.5H3.75a.75.75 0 0 0 0 1.5m16.5 10.5H3.75a.75.75 0 1 0 0 1.5h16.5a.75.75 0 1 0 0-1.5"
	  })));
	};

	var _path$14;
	function _extends$17() { return _extends$17 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$17.apply(null, arguments); }
	var SvgMagnifyingGlassMinusFill = function SvgMagnifyingGlassMinusFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$17({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$14 || (_path$14 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m21.531 20.47-4.693-4.693a8.27 8.27 0 1 0-1.061 1.06l4.693 4.694a.75.75 0 0 0 1.061-1.061m-8.03-9.22h-6a.75.75 0 1 1 0-1.5h6a.75.75 0 1 1 0 1.5"
	  })));
	};

	var _path$13;
	function _extends$16() { return _extends$16 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$16.apply(null, arguments); }
	var SvgMagnifyingGlassMinus = function SvgMagnifyingGlassMinus(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$16({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$13 || (_path$13 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M14.25 10.5a.75.75 0 0 1-.75.75h-6a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 .75.75m7.28 11.03a.747.747 0 0 1-1.06 0l-4.693-4.693a8.26 8.26 0 1 1 1.06-1.06l4.694 4.693a.75.75 0 0 1 0 1.06ZM10.5 17.25a6.75 6.75 0 1 0-6.75-6.75 6.76 6.76 0 0 0 6.75 6.75"
	  })));
	};

	var _path$12;
	function _extends$15() { return _extends$15 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$15.apply(null, arguments); }
	var SvgMagnifyingGlassPlusFill = function SvgMagnifyingGlassPlusFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$15({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$12 || (_path$12 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m21.531 20.47-4.693-4.693a8.27 8.27 0 1 0-1.061 1.06l4.693 4.694a.75.75 0 0 0 1.061-1.061m-8.03-9.22h-2.25v2.25a.75.75 0 1 1-1.5 0v-2.25H7.5a.75.75 0 1 1 0-1.5h2.25V7.5a.75.75 0 1 1 1.5 0v2.25h2.25a.75.75 0 1 1 0 1.5Z"
	  })));
	};

	var _path$11;
	function _extends$14() { return _extends$14 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$14.apply(null, arguments); }
	var SvgMagnifyingGlassPlus = function SvgMagnifyingGlassPlus(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$14({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$11 || (_path$11 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M14.25 10.5a.75.75 0 0 1-.75.75h-2.25v2.25a.75.75 0 1 1-1.5 0v-2.25H7.5a.75.75 0 1 1 0-1.5h2.25V7.5a.75.75 0 0 1 1.5 0v2.25h2.25a.75.75 0 0 1 .75.75m7.28 11.03a.747.747 0 0 1-1.06 0l-4.693-4.693a8.26 8.26 0 1 1 1.06-1.06l4.694 4.693a.75.75 0 0 1 0 1.06ZM10.5 17.25a6.75 6.75 0 1 0-6.75-6.75 6.76 6.76 0 0 0 6.75 6.75"
	  })));
	};

	var _path$10;
	function _extends$13() { return _extends$13 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$13.apply(null, arguments); }
	var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$13({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$10 || (_path$10 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m21.53 20.47-4.693-4.693a8.26 8.26 0 1 0-1.06 1.06l4.693 4.694a.75.75 0 1 0 1.06-1.061M3.75 10.5a6.75 6.75 0 1 1 6.75 6.75 6.76 6.76 0 0 1-6.75-6.75"
	  })));
	};

	var _path$$;
	function _extends$12() { return _extends$12 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$12.apply(null, arguments); }
	var SvgMaleFill = function SvgMaleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$12({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$$ || (_path$$ = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M13.777 2.223Q13.055 1.499 12 1.5q-1.055 0-1.777.723Q9.499 2.945 9.5 4q0 1.055.723 1.777.722.723 1.777.723t1.777-.723Q14.5 5.055 14.5 4t-.723-1.777m1.426 5.449a1.8 1.8 0 0 0-1.328-.547h-.43q-.702.312-1.445.312t-1.445-.312h-.43q-.781 0-1.328.547A1.8 1.8 0 0 0 8.25 9v5.313q0 .39.273.663a.9.9 0 0 0 .665.274h.624v5.313q0 .39.274.664a.9.9 0 0 0 .664.273h2.5q.39 0 .664-.273a.9.9 0 0 0 .274-.665V15.25h.624q.39 0 .665-.274a.9.9 0 0 0 .273-.664V9q0-.781-.547-1.328",
	    clipRule: "evenodd"
	  })));
	};

	var _path$_;
	function _extends$11() { return _extends$11 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$11.apply(null, arguments); }
	var SvgMapPinFill = function SvgMapPinFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$11({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$_ || (_path$_ = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 1.5a8.26 8.26 0 0 0-8.25 8.25c0 7.06 7.5 12.39 7.82 12.614a.75.75 0 0 0 .86 0c.32-.223 7.82-5.555 7.82-12.614A8.26 8.26 0 0 0 12 1.5m0 5.25a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
	  })));
	};

	var _path$Z;
	function _extends$10() { return _extends$10 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$10.apply(null, arguments); }
	var SvgMapPin = function SvgMapPin(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$10({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$Z || (_path$Z = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 6a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 6m0 6a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5m0-10.5a8.26 8.26 0 0 0-8.25 8.25c0 2.944 1.36 6.064 3.938 9.023a23.8 23.8 0 0 0 3.885 3.591.75.75 0 0 0 .861 0 23.8 23.8 0 0 0 3.879-3.59c2.573-2.96 3.937-6.08 3.937-9.024A8.26 8.26 0 0 0 12 1.5m0 19.313c-1.55-1.22-6.75-5.696-6.75-11.063a6.75 6.75 0 0 1 13.5 0c0 5.365-5.2 9.844-6.75 11.063"
	  })));
	};

	var _path$Y;
	function _extends$$() { return _extends$$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$$.apply(null, arguments); }
	var SvgMinusCircleFill = function SvgMinusCircleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$$({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$Y || (_path$Y = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m3.75 10.5h-7.5a.75.75 0 1 1 0-1.5h7.5a.75.75 0 1 1 0 1.5"
	  })));
	};

	var _path$X;
	function _extends$_() { return _extends$_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$_.apply(null, arguments); }
	var SvgMinusCircle = function SvgMinusCircle(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$_({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$X || (_path$X = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M16.5 12a.75.75 0 0 1-.75.75h-7.5a.75.75 0 1 1 0-1.5h7.5a.75.75 0 0 1 .75.75m5.25 0A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12m-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12"
	  })));
	};

	var _path$W;
	function _extends$Z() { return _extends$Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Z.apply(null, arguments); }
	var SvgMinus = function SvgMinus(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$Z({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$W || (_path$W = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 12a.75.75 0 0 1-.75.75H3.75a.75.75 0 1 1 0-1.5h16.5A.75.75 0 0 1 21 12"
	  })));
	};

	var _path$V;
	function _extends$Y() { return _extends$Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Y.apply(null, arguments); }
	var SvgPackageFill = function SvgPackageFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$Y({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$V || (_path$V = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.97 6.201-8.25-4.514a1.49 1.49 0 0 0-1.44 0L3.03 6.203a1.5 1.5 0 0 0-.78 1.313v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.515a1.49 1.49 0 0 0 1.44 0l8.25-4.515a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.316M12 3l7.533 4.125-2.792 1.527-7.533-4.125zm0 8.25L4.467 7.125l3.18-1.741 7.532 4.125zm8.25 5.236-7.5 4.105v-8.045l3-1.641v3.345a.75.75 0 1 0 1.5 0v-4.166l3-1.642z"
	  })));
	};

	var _path$U;
	function _extends$X() { return _extends$X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$X.apply(null, arguments); }
	var SvgPackage = function SvgPackage(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$X({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$U || (_path$U = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.97 6.201-8.25-4.514a1.49 1.49 0 0 0-1.44 0L3.03 6.203a1.5 1.5 0 0 0-.78 1.313v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.515a1.49 1.49 0 0 0 1.44 0l8.25-4.515a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.316M12 3l7.532 4.125-2.791 1.528-7.533-4.125zm0 8.25L4.468 7.125l3.178-1.74 7.532 4.125zM3.75 8.437l7.5 4.105v8.043l-7.5-4.102zm16.5 8.042-7.5 4.106v-8.04l3-1.641v3.346a.75.75 0 1 0 1.5 0v-4.167l3-1.646z"
	  })));
	};

	var _g$2, _defs$2;
	function _extends$W() { return _extends$W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$W.apply(null, arguments); }
	var SvgPaperPlaneTiltFill = function SvgPaperPlaneTiltFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$W({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _g$2 || (_g$2 = /*#__PURE__*/React__namespace.createElement("g", {
	    clipPath: "url(#paper-plane-tilt-fill_svg__a)"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.694 4.157v.014l-5.457 17.994a1.49 1.49 0 0 1-1.441 1.085 1.49 1.49 0 0 1-1.352-.858L10.03 15.39a.375.375 0 0 1 .072-.43l5.43-5.43a.75.75 0 0 0-1.06-1.06L9.04 13.9a.37.37 0 0 1-.43.073L1.602 10.56a1.5 1.5 0 0 1 .234-2.794L19.829 2.31h.014a1.5 1.5 0 0 1 1.85 1.847Z"
	  }))), _defs$2 || (_defs$2 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
	    id: "paper-plane-tilt-fill_svg__a"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M0 0h24v24H0z"
	  })))));
	};

	var _path$T;
	function _extends$V() { return _extends$V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$V.apply(null, arguments); }
	var SvgPaperPlaneTilt = function SvgPaperPlaneTilt(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$V({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$T || (_path$T = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.311 2.689a1.5 1.5 0 0 0-1.468-.383h-.014L1.835 7.766A1.5 1.5 0 0 0 1.6 10.56l7.961 3.877 3.872 7.957a1.49 1.49 0 0 0 1.483.85 1.49 1.49 0 0 0 1.313-1.079l5.456-17.994v-.014a1.5 1.5 0 0 0-.375-1.468Zm-6.514 19.047-.005.013v-.006l-3.756-7.716 4.5-4.5a.75.75 0 0 0-1.06-1.06l-4.5 4.5L2.257 9.21h-.006.013L20.25 3.75l-5.454 17.986Z"
	  })));
	};

	var _path$S;
	function _extends$U() { return _extends$U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$U.apply(null, arguments); }
	var SvgPencilSimpleFill = function SvgPencilSimpleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$U({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$S || (_path$S = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m21.31 6.879-4.188-4.19a1.5 1.5 0 0 0-2.122 0L3.44 14.25A1.5 1.5 0 0 0 3 15.31v4.19A1.5 1.5 0 0 0 4.5 21h4.19a1.5 1.5 0 0 0 1.06-.44L21.31 9a1.5 1.5 0 0 0 0-2.121M18 10.189 13.81 6l2.25-2.25 4.19 4.189z"
	  })));
	};

	var _path$R;
	function _extends$T() { return _extends$T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$T.apply(null, arguments); }
	var SvgPencilSimple = function SvgPencilSimple(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$T({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$R || (_path$R = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m21.31 6.879-4.188-4.19a1.5 1.5 0 0 0-2.122 0L3.44 14.25A1.5 1.5 0 0 0 3 15.31v4.19A1.5 1.5 0 0 0 4.5 21h4.19a1.5 1.5 0 0 0 1.06-.44L21.31 9a1.5 1.5 0 0 0 0-2.121M8.69 19.5H4.5v-4.19l8.25-8.25 4.19 4.19zM18 10.19 13.81 6l2.25-2.25 4.19 4.189z"
	  })));
	};

	var _path$Q;
	function _extends$S() { return _extends$S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$S.apply(null, arguments); }
	var SvgPhoneFill = function SvgPhoneFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$S({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$Q || (_path$Q = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.739 16.414A5.275 5.275 0 0 1 16.5 21C9.056 21 3 14.944 3 7.5a5.274 5.274 0 0 1 4.586-5.239 1.5 1.5 0 0 1 1.558.893l1.98 4.42v.011A1.5 1.5 0 0 1 11.005 9l-.053.072L9 11.386c.702 1.427 2.195 2.906 3.64 3.61l2.282-1.941a1.5 1.5 0 0 1 1.492-.184l.013.006 4.416 1.979a1.5 1.5 0 0 1 .896 1.558"
	  })));
	};

	var _path$P;
	function _extends$R() { return _extends$R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$R.apply(null, arguments); }
	var SvgPhone = function SvgPhone(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$R({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$P || (_path$P = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.847 14.856-4.416-1.98-.013-.005a1.5 1.5 0 0 0-1.492.184L12.644 15c-1.446-.702-2.938-2.183-3.64-3.61l1.948-2.317a1.5 1.5 0 0 0 .177-1.484v-.011L9.144 3.154a1.5 1.5 0 0 0-1.558-.893A5.274 5.274 0 0 0 3 7.5C3 14.944 9.056 21 16.5 21a5.275 5.275 0 0 0 5.239-4.586 1.5 1.5 0 0 0-.892-1.558M16.5 19.5a12.013 12.013 0 0 1-12-12 3.77 3.77 0 0 1 3.27-3.75v.011l1.968 4.407L7.8 10.487l-.053.072a1.5 1.5 0 0 0-.094 1.472c.85 1.737 2.6 3.474 4.355 4.323a1.5 1.5 0 0 0 1.477-.107l.07-.053 2.278-1.944 4.407 1.974h.01A3.77 3.77 0 0 1 16.5 19.5"
	  })));
	};

	var _path$O;
	function _extends$Q() { return _extends$Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Q.apply(null, arguments); }
	var SvgPinterestLogoFill = function SvgPinterestLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$Q({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$O || (_path$O = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.5 12.066c-.036 5.295-4.356 9.63-9.651 9.683a9.8 9.8 0 0 1-2.432-.281.375.375 0 0 1-.273-.456l.81-3.239a5.7 5.7 0 0 0 2.546.602c3.468 0 6.253-3.136 5.982-6.877A6.75 6.75 0 1 0 6.49 14.53a.75.75 0 0 0 1.009.402.77.77 0 0 0 .375-.983 5.25 5.25 0 1 1 10.111-2.337c.201 2.862-1.887 5.262-4.486 5.262-.765 0-1.515-.21-2.17-.604l1.397-5.59a.75.75 0 0 0-1.455-.363L8.754 20.392a.375.375 0 0 1-.535.242 9.75 9.75 0 0 1-5.22-8.739c.057-5.284 4.376-9.596 9.657-9.645a9.75 9.75 0 0 1 9.844 9.816"
	  })));
	};

	var _path$N;
	function _extends$P() { return _extends$P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$P.apply(null, arguments); }
	var SvgPinterestLogo = function SvgPinterestLogo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$P({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$N || (_path$N = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 10.5c0 2.116-.74 4.05-2.084 5.448C17.662 17.25 15.96 18 14.25 18c-1.676 0-2.796-.55-3.51-1.125L9.73 21.17a.75.75 0 0 1-.902.56.75.75 0 0 1-.563-.903l3-12.75a.75.75 0 0 1 1.46.343l-1.584 6.732c.296.41 1.168 1.347 3.109 1.347 2.58 0 5.25-2.245 5.25-6a6.75 6.75 0 1 0-12.597 3.375.75.75 0 0 1-1.299.75A8.25 8.25 0 1 1 21 10.5"
	  })));
	};

	var _path$M;
	function _extends$O() { return _extends$O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$O.apply(null, arguments); }
	var SvgPlayCircleFill = function SvgPlayCircleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$O({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$M || (_path$M = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m3.802 10.367-4.875 3.375a.751.751 0 0 1-1.177-.617v-6.75a.75.75 0 0 1 1.177-.617l4.875 3.375a.75.75 0 0 1 0 1.234"
	  })));
	};

	var _path$L;
	function _extends$N() { return _extends$N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$N.apply(null, arguments); }
	var SvgPlayCircle = function SvgPlayCircle(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$N({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$L || (_path$L = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25m4.523-8.886-6-3.75a.75.75 0 0 0-1.148.636v7.5a.75.75 0 0 0 1.148.636l6-3.75a.75.75 0 0 0 0-1.272m-5.648 3.033V9.603L14.71 12z"
	  })));
	};

	var _path$K;
	function _extends$M() { return _extends$M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$M.apply(null, arguments); }
	var SvgPlusCircleFill = function SvgPlusCircleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$M({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$K || (_path$K = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m3.75 10.5h-3v3a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5h3v-3a.75.75 0 1 1 1.5 0v3h3a.75.75 0 1 1 0 1.5"
	  })));
	};

	var _path$J;
	function _extends$L() { return _extends$L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$L.apply(null, arguments); }
	var SvgPlusCircle = function SvgPlusCircle(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$L({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$J || (_path$J = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25M16.5 12a.75.75 0 0 1-.75.75h-3v3a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5h3v-3a.75.75 0 1 1 1.5 0v3h3a.75.75 0 0 1 .75.75"
	  })));
	};

	var _path$I;
	function _extends$K() { return _extends$K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$K.apply(null, arguments); }
	var SvgPlus = function SvgPlus(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$K({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$I || (_path$I = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 12a.75.75 0 0 1-.75.75h-7.5v7.5a.75.75 0 1 1-1.5 0v-7.5h-7.5a.75.75 0 1 1 0-1.5h7.5v-7.5a.75.75 0 1 1 1.5 0v7.5h7.5A.75.75 0 0 1 21 12"
	  })));
	};

	var _path$H;
	function _extends$J() { return _extends$J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$J.apply(null, arguments); }
	var SvgPrinterFill = function SvgPrinterFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$J({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$H || (_path$H = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.5 9v7.5a.75.75 0 0 1-.75.75h-3v3A.75.75 0 0 1 18 21H6a.75.75 0 0 1-.75-.75v-3h-3a.75.75 0 0 1-.75-.75V9c0-1.24 1.065-2.25 2.375-2.25H5.25v-3A.75.75 0 0 1 6 3h12a.75.75 0 0 1 .75.75v3h1.375c1.31 0 2.375 1.01 2.375 2.25M6.75 6.75h10.5V4.5H6.75zM17.25 15H6.75v4.5h10.5zm1.5-4.125a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0"
	  })));
	};

	var _path$G;
	function _extends$I() { return _extends$I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$I.apply(null, arguments); }
	var SvgPrinter = function SvgPrinter(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$I({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$G || (_path$G = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.125 6.75H18.75v-3A.75.75 0 0 0 18 3H6a.75.75 0 0 0-.75.75v3H3.875C2.565 6.75 1.5 7.76 1.5 9v7.5a.75.75 0 0 0 .75.75h3v3A.75.75 0 0 0 6 21h12a.75.75 0 0 0 .75-.75v-3h3a.75.75 0 0 0 .75-.75V9c0-1.24-1.065-2.25-2.375-2.25M6.75 4.5h10.5v2.25H6.75zm10.5 15H6.75V15h10.5zM21 15.75h-2.25v-1.5a.75.75 0 0 0-.75-.75H6a.75.75 0 0 0-.75.75v1.5H3V9c0-.413.393-.75.875-.75h16.25c.482 0 .875.337.875.75zm-2.25-4.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
	  })));
	};

	var _path$F, _path2$1;
	function _extends$H() { return _extends$H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$H.apply(null, arguments); }
	var SvgRadioButtonFill = function SvgRadioButtonFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$H({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$F || (_path$F = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25"
	  })), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M17.25 12a5.25 5.25 0 1 1-10.499 0 5.25 5.25 0 0 1 10.499 0"
	  })));
	};

	var _path$E;
	function _extends$G() { return _extends$G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$G.apply(null, arguments); }
	var SvgRadioButton = function SvgRadioButton(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$G({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$E || (_path$E = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12",
	    clipRule: "evenodd"
	  })));
	};

	var _path$D;
	function _extends$F() { return _extends$F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$F.apply(null, arguments); }
	var SvgRulerFill = function SvgRulerFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$F({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$D || (_path$D = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.061 9 9 22.06a1.5 1.5 0 0 1-2.122 0l-4.94-4.938a1.5 1.5 0 0 1 0-2.122l2.735-2.735a.377.377 0 0 1 .53 0l3.266 3.266a.75.75 0 0 0 1.098-.04.767.767 0 0 0-.056-1.04l-3.247-3.247a.375.375 0 0 1 0-.53L7.67 9.268a.375.375 0 0 1 .531 0l3.265 3.265a.75.75 0 0 0 1.098-.04.767.767 0 0 0-.056-1.04L9.265 8.204a.375.375 0 0 1 0-.53l1.406-1.406a.375.375 0 0 1 .53 0l3.265 3.265a.75.75 0 0 0 1.099-.04.767.767 0 0 0-.057-1.04l-3.243-3.249a.375.375 0 0 1 0-.53L15 1.94a1.5 1.5 0 0 1 2.121 0l4.94 4.938a1.5 1.5 0 0 1 0 2.122"
	  })));
	};

	var _path$C;
	function _extends$E() { return _extends$E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$E.apply(null, arguments); }
	var SvgRuler = function SvgRuler(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$E({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$C || (_path$C = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m22.061 6.878-4.94-4.938a1.5 1.5 0 0 0-2.121 0L1.938 15a1.5 1.5 0 0 0 0 2.122l4.94 4.938a1.5 1.5 0 0 0 2.122 0L22.06 9a1.5 1.5 0 0 0 0-2.122ZM7.938 21 3 16.06l3-3 2.47 2.47a.75.75 0 1 0 1.06-1.06L7.06 12 9 10.06l2.47 2.47a.75.75 0 1 0 1.06-1.06L10.06 9 12 7.06l2.47 2.47a.75.75 0 1 0 1.06-1.06L13.06 6l3-3L21 7.94z"
	  })));
	};

	var _path$B;
	function _extends$D() { return _extends$D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$D.apply(null, arguments); }
	var SvgShoppingCartFill = function SvgShoppingCartFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$D({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$B || (_path$B = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.576 5.52A.75.75 0 0 0 21 5.25H5.876l-.57-3.134a.75.75 0 0 0-.738-.616H2.25a.75.75 0 0 0 0 1.5h1.688l2.396 13.152c.07.39.243.755.5 1.057a2.625 2.625 0 1 0 4.162.791h4.258a2.625 2.625 0 1 0 2.37-1.5H8.548a.75.75 0 0 1-.738-.616l-.297-1.634h10.875a2.25 2.25 0 0 0 2.214-1.848l1.14-6.268a.75.75 0 0 0-.165-.615ZM9.75 19.124a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m9 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
	  })));
	};

	var _path$A;
	function _extends$C() { return _extends$C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$C.apply(null, arguments); }
	var SvgShoppingCart = function SvgShoppingCart(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$C({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$A || (_path$A = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.576 5.52A.75.75 0 0 0 21 5.25H5.876l-.57-3.134a.75.75 0 0 0-.738-.616H2.25a.75.75 0 0 0 0 1.5h1.688l2.396 13.152c.07.39.243.755.5 1.057a2.625 2.625 0 1 0 4.162.791h4.258a2.625 2.625 0 1 0 2.37-1.5H8.548a.75.75 0 0 1-.738-.616l-.297-1.634h10.875a2.25 2.25 0 0 0 2.214-1.848l1.14-6.268a.75.75 0 0 0-.165-.615ZM9.75 19.124a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m9 0a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0m.375-6.99a.75.75 0 0 1-.74.615H7.238l-1.09-6H20.1l-.976 5.384Z"
	  })));
	};

	var _path$z;
	function _extends$B() { return _extends$B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$B.apply(null, arguments); }
	var SvgSlidersHorizontalFill = function SvgSlidersHorizontalFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$B({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$z || (_path$z = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M3 7.5a.75.75 0 0 1 .75-.75h3.485a2.625 2.625 0 0 1 5.03 0h7.985a.75.75 0 1 1 0 1.5h-7.985a2.625 2.625 0 0 1-5.03 0H3.75A.75.75 0 0 1 3 7.5m17.25 8.25h-1.985a2.625 2.625 0 0 0-5.03 0H3.75a.75.75 0 1 0 0 1.5h9.485a2.625 2.625 0 0 0 5.03 0h1.985a.75.75 0 1 0 0-1.5"
	  })));
	};

	var _path$y;
	function _extends$A() { return _extends$A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$A.apply(null, arguments); }
	var SvgSlidersHorizontal = function SvgSlidersHorizontal(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$A({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$y || (_path$y = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M3.75 8.25h3.094a3 3 0 0 0 5.812 0h7.594a.75.75 0 1 0 0-1.5h-7.594a3 3 0 0 0-5.812 0H3.75a.75.75 0 0 0 0 1.5m6-2.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m10.5 9.75h-1.594a3 3 0 0 0-5.812 0H3.75a.75.75 0 1 0 0 1.5h9.094a3 3 0 0 0 5.812 0h1.594a.75.75 0 1 0 0-1.5M15.75 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
	  })));
	};

	var _path$x;
	function _extends$z() { return _extends$z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$z.apply(null, arguments); }
	var SvgSquare = function SvgSquare(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$z({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$x || (_path$x = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3m0 16.5h-15v-15h15z"
	  })));
	};

	var _path$w;
	function _extends$y() { return _extends$y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$y.apply(null, arguments); }
	var SvgStarFill = function SvgStarFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$y({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$w || (_path$w = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m21.965 10.767-4.22 3.64 1.286 5.445a1.538 1.538 0 0 1-2.297 1.67L12 18.608l-4.737 2.914a1.538 1.538 0 0 1-2.294-1.67l1.29-5.445-4.22-3.64a1.543 1.543 0 0 1 .875-2.705l5.53-.446 2.135-5.164a1.534 1.534 0 0 1 2.837 0l2.133 5.164 5.532.446a1.543 1.543 0 0 1 .878 2.706h.006Z"
	  })));
	};

	var _path$v;
	function _extends$x() { return _extends$x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$x.apply(null, arguments); }
	var SvgStar = function SvgStar(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$x({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$v || (_path$v = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.423 9.118a1.535 1.535 0 0 0-1.336-1.056l-5.532-.446-2.135-5.165a1.534 1.534 0 0 0-2.838 0L8.448 7.615l-5.534.447a1.543 1.543 0 0 0-.878 2.706l4.218 3.64-1.285 5.443a1.536 1.536 0 0 0 2.297 1.671L12 18.608l4.738 2.914a1.539 1.539 0 0 0 2.294-1.67l-1.29-5.445 4.218-3.64a1.54 1.54 0 0 0 .463-1.649m-1.438.513-4.565 3.937a.75.75 0 0 0-.24.742l1.395 5.887a.035.035 0 0 1-.016.045c-.017.014-.022.01-.036 0l-5.13-3.154a.75.75 0 0 0-.786 0l-5.13 3.156c-.014.009-.017.012-.035 0a.034.034 0 0 1-.016-.045l1.395-5.887a.75.75 0 0 0-.24-.742L3.015 9.633c-.01-.01-.021-.018-.012-.047s.017-.026.031-.027l5.993-.484a.75.75 0 0 0 .63-.463l2.308-5.589c.007-.016.01-.023.033-.023.022 0 .025.007.032.023l2.314 5.589a.75.75 0 0 0 .633.461l5.992.484c.014 0 .023 0 .031.027s0 .037-.015.047"
	  })));
	};

	var _path$u;
	function _extends$w() { return _extends$w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$w.apply(null, arguments); }
	var SvgStorefrontFill = function SvgStorefrontFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$w({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$u || (_path$u = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M3.325 3.777a.95.95 0 0 1 .85-.527h15.65c.36 0 .69.204.85.527l1.976 3.972a.95.95 0 0 1 .099.423V11.3a.95.95 0 0 1-.95.95h-4.05V10a.75.75 0 0 0-1.5 0v2.25h-3.5V10a.75.75 0 0 0-1.5 0v2.25h-3.5V10a.75.75 0 0 0-1.5 0v2.25H2.2a.95.95 0 0 1-.95-.95V8.172a.95.95 0 0 1 .1-.423zM3.25 13.75V20a.75.75 0 0 0 1.5 0v-6.25zm5.5 0v5.75c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-5.75h-1.5v5.5h-9.5v-5.5z"
	  })));
	};

	var _path$t;
	function _extends$v() { return _extends$v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$v.apply(null, arguments); }
	var SvgStorefront = function SvgStorefront(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$v({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$t || (_path$t = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.552 4.75 2.75 9.1v3.15h3.5V10a.75.75 0 0 1 1.5 0v2.25h3.5V10a.75.75 0 0 1 1.5 0v2.25h3.5V10a.75.75 0 0 1 1.5 0v2.25h3.5V9.1l-1.802-4.35zm15.198 9h-9.5v5.5h9.5zm-11 0h-4V20a.75.75 0 0 1-1.5 0v-6.25H2.5c-.69 0-1.25-.56-1.25-1.25V9.05q0-.25.095-.479l1.886-4.55a1.25 1.25 0 0 1 1.154-.771h15.23c.505 0 .96.304 1.155.771l1.885 4.55q.095.23.095.479v3.45c0 .69-.56 1.25-1.25 1.25h-.25v5.75c0 .69-.56 1.25-1.25 1.25H10c-.69 0-1.25-.56-1.25-1.25z",
	    clipRule: "evenodd"
	  })));
	};

	var _path$s;
	function _extends$u() { return _extends$u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$u.apply(null, arguments); }
	var SvgStravaLogoFill = function SvgStravaLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$u({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$s || (_path$s = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m15.174 17.449-1.958-3.773h-2.872L15.174 23 20 13.676h-2.873M10.56 8.543l2.657 5.132h3.91L10.56 1 4 13.676h3.907"
	  })));
	};

	var _path$r;
	function _extends$t() { return _extends$t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$t.apply(null, arguments); }
	var SvgTShirtFill = function SvgTShirtFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$t({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$r || (_path$r = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M23.211 5.74 18.36 3.093a.75.75 0 0 0-.36-.094h-3a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 3H6a.75.75 0 0 0-.36.094L.79 5.739a1.477 1.477 0 0 0-.62 1.994l1.807 3.45A1.53 1.53 0 0 0 3.344 12H5.25v7.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V12h1.907a1.54 1.54 0 0 0 1.366-.817l1.807-3.45a1.477 1.477 0 0 0-.619-1.994ZM3.344 10.5a.06.06 0 0 1-.039-.012L1.508 7.056 5.25 5.014V10.5zm17.35-.013a.05.05 0 0 1-.038.013H18.75V5.014l3.742 2.042z"
	  })));
	};

	var _path$q;
	function _extends$s() { return _extends$s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$s.apply(null, arguments); }
	var SvgTShirt = function SvgTShirt(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$s({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$q || (_path$q = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M23.211 5.74 18.36 3.093a.75.75 0 0 0-.36-.094h-3a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 3H6a.75.75 0 0 0-.36.094L.79 5.739a1.477 1.477 0 0 0-.62 1.994l1.807 3.45A1.53 1.53 0 0 0 3.344 12H5.25v7.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V12h1.907a1.54 1.54 0 0 0 1.366-.817l1.807-3.45a1.477 1.477 0 0 0-.619-1.994ZM3.344 10.5a.06.06 0 0 1-.039-.012L1.508 7.056 5.25 5.014V10.5zm13.906 9H6.75v-15h1.575a3.75 3.75 0 0 0 7.348 0h1.577zm3.445-9.013a.05.05 0 0 1-.038.013H18.75V5.014l3.742 2.042z"
	  })));
	};

	var _path$p;
	function _extends$r() { return _extends$r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$r.apply(null, arguments); }
	var SvgTagFill = function SvgTagFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$r({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$p || (_path$p = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.81 12.75 11.5 3.44A1.5 1.5 0 0 0 10.44 3H1.75a.75.75 0 0 0-.75.75v8.69a1.5 1.5 0 0 0 .44 1.06l9.31 9.31a1.5 1.5 0 0 0 2.122 0l7.938-7.938a1.5 1.5 0 0 0 0-2.122M5.875 9a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25"
	  })));
	};

	var _path$o;
	function _extends$q() { return _extends$q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$q.apply(null, arguments); }
	var SvgTag = function SvgTag(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$q({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$o || (_path$o = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.81 12.75 13.5 3.44A1.5 1.5 0 0 0 12.44 3H3.75a.75.75 0 0 0-.75.75v8.69a1.5 1.5 0 0 0 .44 1.06l9.31 9.31a1.5 1.5 0 0 0 2.122 0l7.938-7.938a1.5 1.5 0 0 0 0-2.122m-9 9L4.5 12.44V4.5h7.94l9.31 9.31zM9 7.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
	  })));
	};

	var _path$n;
	function _extends$p() { return _extends$p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$p.apply(null, arguments); }
	var SvgTicketFill = function SvgTicketFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$p({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$n || (_path$n = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 9.75A.75.75 0 0 0 22.5 9V6A1.5 1.5 0 0 0 21 4.5H3A1.5 1.5 0 0 0 1.5 6v3a.75.75 0 0 0 .75.75 2.25 2.25 0 1 1 0 4.5.75.75 0 0 0-.75.75v3A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5v-3a.75.75 0 0 0-.75-.75 2.25 2.25 0 0 1 0-4.5M3 15.675a3.75 3.75 0 0 0 0-7.35V6h5.25v12H3z"
	  })));
	};

	var _path$m;
	function _extends$o() { return _extends$o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$o.apply(null, arguments); }
	var SvgTicket = function SvgTicket(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$o({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$m || (_path$m = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 9.75A.75.75 0 0 0 22.5 9V6A1.5 1.5 0 0 0 21 4.5H3A1.5 1.5 0 0 0 1.5 6v3a.75.75 0 0 0 .75.75 2.25 2.25 0 1 1 0 4.5.75.75 0 0 0-.75.75v3A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5v-3a.75.75 0 0 0-.75-.75 2.25 2.25 0 0 1 0-4.5M3 15.675a3.75 3.75 0 0 0 0-7.35V6h5.25v12H3zm18 0V18H9.75V6H21v2.325a3.75 3.75 0 0 0 0 7.35"
	  })));
	};

	var _path$l;
	function _extends$n() { return _extends$n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$n.apply(null, arguments); }
	var SvgTiktokLogoFill = function SvgTiktokLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$n({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$l || (_path$l = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.75 7.5v3.75A.75.75 0 0 1 21 12a9.7 9.7 0 0 1-4.5-1.098v3.723a7.125 7.125 0 0 1-14.25 0c0-3.46 2.523-6.518 5.869-7.114A.75.75 0 0 1 9 8.25v4.002a.75.75 0 0 1-.428.678 1.875 1.875 0 1 0 2.678 1.695V2.25A.75.75 0 0 1 12 1.5h3.75a.75.75 0 0 1 .75.75 4.504 4.504 0 0 0 4.5 4.5.75.75 0 0 1 .75.75"
	  })));
	};

	var _path$k;
	function _extends$m() { return _extends$m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$m.apply(null, arguments); }
	var SvgTiktokLogo = function SvgTiktokLogo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$m({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$k || (_path$k = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21 6.75a4.505 4.505 0 0 1-4.5-4.5.75.75 0 0 0-.75-.75H12a.75.75 0 0 0-.75.75v12.375a1.875 1.875 0 1 1-2.678-1.695.75.75 0 0 0 .428-.678V8.25a.75.75 0 0 0-.881-.739c-3.346.596-5.869 3.655-5.869 7.114a7.125 7.125 0 1 0 14.25 0v-3.723A9.7 9.7 0 0 0 21 12a.75.75 0 0 0 .75-.75V7.5a.75.75 0 0 0-.75-.75m-.75 3.716a8.2 8.2 0 0 1-4.062-1.514.75.75 0 0 0-1.188.61v5.063a5.625 5.625 0 1 1-11.25 0c0-2.428 1.56-4.606 3.75-5.4v2.594a3.374 3.374 0 1 0 5.25 2.806V3h2.297a6.01 6.01 0 0 0 5.203 5.203z"
	  })));
	};

	var _path$j;
	function _extends$l() { return _extends$l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$l.apply(null, arguments); }
	var SvgTrashFill = function SvgTrashFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$l({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$j || (_path$j = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.25 4.5H16.5v-.75a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 7.5 3.75v.75H3.75a.75.75 0 0 0 0 1.5h.75v13.5A1.5 1.5 0 0 0 6 21h12a1.5 1.5 0 0 0 1.5-1.5V6h.75a.75.75 0 1 0 0-1.5M10.5 15.75a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.5 0zm4.5 0a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0zM15 4.5H9v-.75A.75.75 0 0 1 9.75 3h4.5a.75.75 0 0 1 .75.75z"
	  })));
	};

	var _path$i;
	function _extends$k() { return _extends$k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$k.apply(null, arguments); }
	var SvgTrash = function SvgTrash(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$k({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$i || (_path$i = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.25 4.5H16.5v-.75a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 7.5 3.75v.75H3.75a.75.75 0 0 0 0 1.5h.75v13.5A1.5 1.5 0 0 0 6 21h12a1.5 1.5 0 0 0 1.5-1.5V6h.75a.75.75 0 1 0 0-1.5M9 3.75A.75.75 0 0 1 9.75 3h4.5a.75.75 0 0 1 .75.75v.75H9zm9 15.75H6V6h12zm-7.5-9.75v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 1.5 0m4.5 0v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 1 1 1.5 0"
	  })));
	};

	var _path$h, _path2;
	function _extends$j() { return _extends$j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$j.apply(null, arguments); }
	var SvgTruckFill = function SvgTruckFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$j({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$h || (_path$h = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M.5 6a.75.75 0 0 1 .75-.75h16A.75.75 0 0 1 18 6v.75h3.241a1.5 1.5 0 0 1 1.392.938v.002l1.313 3.282a.8.8 0 0 1 .054.278v6a1.5 1.5 0 0 1-1.5 1.5h-1.595a3.001 3.001 0 0 1-5.81 0h-4.69a3.001 3.001 0 0 1-5.81 0H3a1.5 1.5 0 0 1-1.5-1.5V13.5a.75.75 0 0 1 1.5 0v3.75h1.595a3.001 3.001 0 0 1 5.81 0h4.69a3 3 0 0 1 1.405-1.848V6.75H1.25A.75.75 0 0 1 .5 6M18 10.5h4.142l-.9-2.25H18zm-10.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m10.5 0a1.495 1.495 0 0 0-1.5 1.5 1.5 1.5 0 1 0 1.5-1.5",
	    clipRule: "evenodd"
	  })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M1.75 10a.75.75 0 0 1 .75-.75H7a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75"
	  })));
	};

	var _path$g;
	function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$i.apply(null, arguments); }
	var SvgTruck = function SvgTruck(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$i({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$g || (_path$g = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M.5 6a.75.75 0 0 1 .75-.75h16A.75.75 0 0 1 18 6v.75h3.241a1.5 1.5 0 0 1 1.392.938v.002l1.313 3.282a.8.8 0 0 1 .054.278v6a1.5 1.5 0 0 1-1.5 1.5h-1.595a3.001 3.001 0 0 1-5.81 0h-4.69a3.001 3.001 0 0 1-5.81 0H3a1.5 1.5 0 0 1-1.5-1.5V13.5a.75.75 0 0 1 1.5 0v3.75h1.595a3.001 3.001 0 0 1 5.81 0h4.69a3 3 0 0 1 1.405-1.849V6.75H1.25A.75.75 0 0 1 .5 6M18 8.25v2.25h4.142l-.9-2.25zM22.5 12H18v3a3 3 0 0 1 2.905 2.25H22.5zm-5.018 4.592A1.5 1.5 0 0 1 18 16.5a1.5 1.5 0 1 1-.518.092M1.75 10a.75.75 0 0 1 .75-.75H7a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75m5.75 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
	    clipRule: "evenodd"
	  })));
	};

	var _path$f;
	function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
	var SvgUnisexFill = function SvgUnisexFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$h({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$f || (_path$f = /*#__PURE__*/React__namespace.createElement("path", {
	    fillRule: "evenodd",
	    d: "M8.527 2.223Q7.805 1.499 6.75 1.5q-1.055 0-1.777.723Q4.249 2.945 4.25 4q0 1.055.723 1.777.722.723 1.777.723t1.777-.723Q9.25 5.055 9.25 4t-.723-1.777m1.426 5.449a1.8 1.8 0 0 0-1.328-.547h-.43q-.702.312-1.445.312t-1.445-.312h-.43q-.781 0-1.328.547A1.8 1.8 0 0 0 3 9v5.313q0 .39.273.663a.9.9 0 0 0 .664.274h.626v5.313q0 .39.273.664a.9.9 0 0 0 .664.273H8q.39 0 .664-.273a.9.9 0 0 0 .273-.665V15.25h.625q.39 0 .665-.274a.9.9 0 0 0 .273-.664V9q0-.781-.547-1.328m8.507-5.449q-.72-.723-1.776-.723t-1.778.723T14.184 4t.722 1.777 1.778.723q1.054 0 1.777-.723.723-.722.723-1.777t-.723-1.777Zm2.716 13.925q.273-.35.156-.82l-1.875-7.5a.9.9 0 0 0-.332-.508.9.9 0 0 0-.566-.195h-.43q-.703.312-1.445.312t-1.446-.312h-.43a.9.9 0 0 0-.566.195q-.255.196-.332.508l-1.875 7.5q-.117.47.156.82a.89.89 0 0 0 .743.352h2.187v4.063q0 .39.274.664a.9.9 0 0 0 .664.273h1.25q.39 0 .664-.273a.9.9 0 0 0 .273-.665V16.5h2.188a.89.89 0 0 0 .742-.352",
	    clipRule: "evenodd"
	  })));
	};

	var _g$1, _defs$1;
	function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
	var SvgUserCheckFill = function SvgUserCheckFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$g({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _g$1 || (_g$1 = /*#__PURE__*/React__namespace.createElement("g", {
	    clipPath: "url(#user-check-fill_svg__a)"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m23.78 12.53-3 3a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 1 1 1.06-1.06l.97.97 2.47-2.47a.75.75 0 1 1 1.06 1.06M13.5 14.784a6.376 6.376 0 1 0-6.74 0c-1.937.633-3.678 1.817-5.079 3.484A.75.75 0 0 0 2.25 19.5H18a.751.751 0 0 0 .575-1.233c-1.402-1.667-3.144-2.85-5.075-3.484Z"
	  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
	    id: "user-check-fill_svg__a"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M0 0h24v24H0z"
	  })))));
	};

	var _g, _defs;
	function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
	var SvgUserCheck = function SvgUserCheck(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$f({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
	    clipPath: "url(#user-check_svg__a)"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M13.5 14.783a6.375 6.375 0 1 0-6.74 0c-1.937.633-3.678 1.817-5.08 3.484a.75.75 0 1 0 1.15.966c1.88-2.246 4.474-3.483 7.295-3.483s5.414 1.237 7.3 3.483a.75.75 0 1 0 1.149-.966c-1.4-1.667-3.143-2.85-5.074-3.484M5.25 9.375a4.875 4.875 0 1 1 9.75 0 4.875 4.875 0 0 1-9.75 0m18.53 3.156-3 3a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 1 1 1.06-1.062l.97.97 2.47-2.47a.75.75 0 1 1 1.06 1.062"
	  }))), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
	    id: "user-check_svg__a"
	  }, /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M0 0h24v24H0z"
	  })))));
	};

	var _path$e;
	function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
	var SvgUserFill = function SvgUserFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.65 20.625A.75.75 0 0 1 21 21H3a.75.75 0 0 1-.649-1.125c1.428-2.468 3.629-4.238 6.196-5.077a6.75 6.75 0 1 1 6.906 0c2.568.839 4.768 2.609 6.196 5.077a.75.75 0 0 1 0 .75Z"
	  })));
	};

	var _path$d;
	function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
	var SvgUser = function SvgUser(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.648 19.875c-1.427-2.468-3.628-4.238-6.195-5.077a6.75 6.75 0 1 0-6.906 0c-2.568.838-4.768 2.608-6.196 5.077a.75.75 0 1 0 1.298.75C5.416 17.573 8.537 15.75 12 15.75s6.585 1.823 8.351 4.875a.75.75 0 1 0 1.298-.75ZM6.75 9a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0"
	  })));
	};

	var _path$c;
	function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
	var SvgUsersFill = function SvgUsersFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M15.419 18.34a.75.75 0 0 1-.628 1.16H.959a.75.75 0 0 1-.628-1.16 9 9 0 0 1 4.427-3.535 5.625 5.625 0 1 1 6.234 0 9 9 0 0 1 4.427 3.535m8.241-.014a9 9 0 0 0-4.418-3.52 5.625 5.625 0 0 0-5.677-9.688.374.374 0 0 0-.124.562 7.11 7.11 0 0 1 .34 8.432.375.375 0 0 0 .1.519 10.5 10.5 0 0 1 2.799 2.89c.298.456.42 1.005.342 1.544a.375.375 0 0 0 .37.435h5.654a.75.75 0 0 0 .724-.556.77.77 0 0 0-.11-.618"
	  })));
	};

	var _path$b;
	function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
	var SvgUsers = function SvgUsers(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M10.992 14.805a5.625 5.625 0 1 0-6.234 0A9 9 0 0 0 .33 18.34a.75.75 0 1 0 1.256.82 7.5 7.5 0 0 1 12.576 0 .75.75 0 0 0 1.256-.82 9 9 0 0 0-4.427-3.535Zm-7.242-4.68a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0m19.7 9.253a.75.75 0 0 1-1.037-.218 7.48 7.48 0 0 0-6.288-3.41.75.75 0 1 1 0-1.5 4.125 4.125 0 1 0-1.532-7.956.75.75 0 1 1-.557-1.393 5.625 5.625 0 0 1 5.206 9.904 9 9 0 0 1 4.427 3.535.75.75 0 0 1-.218 1.038Z"
	  })));
	};

	var _path$a;
	function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
	var SvgWarningCircleFill = function SvgWarningCircleFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m-.75 5.25a.75.75 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0zm.75 9.75A1.125 1.125 0 1 1 12 15a1.125 1.125 0 0 1 0 2.25"
	  })));
	};

	var _path$9;
	function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
	var SvgWarningCircle = function SvgWarningCircle(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25m-.75-7.5V7.5a.75.75 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0m1.875 3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
	  })));
	};

	var _path$8;
	function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
	var SvgWarningFill = function SvgWarningFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.2 17.634 14.002 3.396a2.322 2.322 0 0 0-4.004 0L1.8 17.634a2.2 2.2 0 0 0 0 2.223A2.28 2.28 0 0 0 3.802 21h16.396a2.28 2.28 0 0 0 2-1.143 2.2 2.2 0 0 0 .002-2.223M11.25 9.75a.75.75 0 1 1 1.5 0v3.75a.75.75 0 0 1-1.5 0zM12 18a1.125 1.125 0 1 1 0-2.25A1.125 1.125 0 0 1 12 18"
	  })));
	};

	var _path$7;
	function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
	var SvgWarning = function SvgWarning(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M22.2 17.634 14.002 3.396a2.322 2.322 0 0 0-4.004 0L1.8 17.634a2.2 2.2 0 0 0 0 2.223A2.28 2.28 0 0 0 3.802 21h16.396a2.28 2.28 0 0 0 2-1.143 2.2 2.2 0 0 0 .002-2.223m-1.3 1.472a.8.8 0 0 1-.701.394H3.802a.8.8 0 0 1-.702-.394.71.71 0 0 1 0-.723l8.2-14.238a.82.82 0 0 1 1.406 0l8.199 14.238a.71.71 0 0 1-.004.723ZM11.25 13.5V9.75a.75.75 0 1 1 1.5 0v3.75a.75.75 0 0 1-1.5 0m1.875 3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
	  })));
	};

	var _path$6;
	function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
	var SvgWhatsappLogoFill = function SvgWhatsappLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m14.304 13.615 2.157 1.076A2.25 2.25 0 0 1 14.25 16.5 6.76 6.76 0 0 1 7.5 9.75a2.25 2.25 0 0 1 1.808-2.207l1.077 2.156-.916 1.363a.75.75 0 0 0-.069.705 5.3 5.3 0 0 0 2.827 2.826.75.75 0 0 0 .71-.062zM21.75 12a9.75 9.75 0 0 1-14.332 8.608l-3.193 1.064a1.5 1.5 0 0 1-1.897-1.897l1.064-3.193A9.75 9.75 0 1 1 21.75 12M18 14.25a.75.75 0 0 0-.414-.671l-3-1.5a.75.75 0 0 0-.75.046l-1.378.92a3.8 3.8 0 0 1-1.5-1.5l.92-1.378a.75.75 0 0 0 .046-.75l-1.5-3A.75.75 0 0 0 9.75 6 3.75 3.75 0 0 0 6 9.75 8.26 8.26 0 0 0 14.25 18 3.75 3.75 0 0 0 18 14.25"
	  })));
	};

	var _path$5;
	function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
	var SvgWhatsappLogo = function SvgWhatsappLogo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m17.586 13.579-3-1.5a.75.75 0 0 0-.75.047l-1.377.918a3.8 3.8 0 0 1-1.5-1.5l.918-1.377a.75.75 0 0 0 .047-.75l-1.5-3A.75.75 0 0 0 9.75 6 3.75 3.75 0 0 0 6 9.75 8.26 8.26 0 0 0 14.25 18 3.75 3.75 0 0 0 18 14.25a.75.75 0 0 0-.414-.671M14.25 16.5A6.76 6.76 0 0 1 7.5 9.75a2.25 2.25 0 0 1 1.81-2.207L10.385 9.7l-.916 1.364a.75.75 0 0 0-.069.704 5.3 5.3 0 0 0 2.827 2.826.75.75 0 0 0 .71-.062l1.37-.913 2.157 1.076A2.25 2.25 0 0 1 14.25 16.5M12 2.25a9.75 9.75 0 0 0-8.608 14.332l-1.064 3.193a1.5 1.5 0 0 0 1.897 1.897l3.193-1.064A9.75 9.75 0 1 0 12 2.25m0 18a8.24 8.24 0 0 1-4.13-1.107.75.75 0 0 0-.614-.063L3.75 20.25l1.17-3.506a.75.75 0 0 0-.063-.613A8.25 8.25 0 1 1 12 20.25"
	  })));
	};

	var _path$4;
	function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
	var SvgXLogoFill = function SvgXLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M20.157 20.61a.75.75 0 0 1-.657.39H15a.75.75 0 0 1-.632-.348l-3.796-5.965-5.517 6.067a.75.75 0 0 1-1.11-1.008l5.791-6.375-5.868-9.218A.75.75 0 0 1 4.5 3H9a.75.75 0 0 1 .633.348l3.796 5.965 5.516-6.067a.75.75 0 0 1 1.11 1.008l-5.79 6.37 5.868 9.224a.75.75 0 0 1 .024.763Z"
	  })));
	};

	var _path$3;
	function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
	var SvgXLogo = function SvgXLogo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m20.133 19.848-5.869-9.223 5.791-6.37a.75.75 0 0 0-1.11-1.01L13.43 9.314 9.633 3.348A.75.75 0 0 0 9 3H4.5a.75.75 0 0 0-.633 1.153l5.87 9.222-5.792 6.375a.75.75 0 1 0 1.11 1.01l5.516-6.068 3.796 5.965A.75.75 0 0 0 15 21h4.5a.75.75 0 0 0 .633-1.152m-4.721-.348-9.546-15h2.719l9.55 15z"
	  })));
	};

	var _path$2;
	function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
	var SvgX = function SvgX(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M19.281 18.22a.75.75 0 1 1-1.061 1.06L12 13.06l-6.219 6.22a.75.75 0 0 1-1.061-1.06L10.94 12 4.72 5.78a.75.75 0 1 1 1.06-1.06L12 10.94l6.219-6.22a.75.75 0 1 1 1.061 1.06L13.061 12z"
	  })));
	};

	var _path$1;
	function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
	var SvgYoutubeLogoFill = function SvgYoutubeLogoFill(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "M21.968 6.518A2.25 2.25 0 0 0 20.61 4.98C17.396 3.739 12.281 3.75 12 3.75s-5.396-.011-8.61 1.23a2.25 2.25 0 0 0-1.358 1.537C1.789 7.454 1.5 9.163 1.5 12s.289 4.547.532 5.483A2.25 2.25 0 0 0 3.39 19.02c3.079 1.188 7.897 1.229 8.548 1.229h.124c.65 0 5.472-.041 8.548-1.23a2.25 2.25 0 0 0 1.358-1.537c.243-.938.532-2.646.532-5.483s-.289-4.547-.532-5.482Zm-6.913 6.093-3.75 2.625a.75.75 0 0 1-1.18-.611v-5.25a.75.75 0 0 1 1.18-.614l3.75 2.625a.75.75 0 0 1 0 1.228z"
	  })));
	};

	var _path;
	function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
	var SvgYoutubeLogo = function SvgYoutubeLogo(props) {
	  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
	    xmlns: "http://www.w3.org/2000/svg",
	    width: 24,
	    height: 24,
	    viewBox: "0 0 24 24"
	  }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
	    d: "m15.416 11.376-4.5-3A.75.75 0 0 0 9.75 9v6a.75.75 0 0 0 1.166.624l4.5-3a.75.75 0 0 0 0-1.248m-4.166 2.222v-3.192L13.648 12zm10.718-7.08A2.25 2.25 0 0 0 20.61 4.98C17.396 3.739 12.281 3.75 12 3.75s-5.396-.011-8.61 1.23a2.25 2.25 0 0 0-1.358 1.537C1.789 7.454 1.5 9.163 1.5 12s.289 4.547.532 5.483A2.25 2.25 0 0 0 3.39 19.02c3.079 1.188 7.897 1.229 8.548 1.229h.124c.65 0 5.472-.041 8.548-1.23a2.25 2.25 0 0 0 1.358-1.537c.243-.938.532-2.646.532-5.483s-.289-4.547-.532-5.482ZM20.516 17.11a.75.75 0 0 1-.447.515c-2.967 1.146-8.014 1.125-8.062 1.125H12c-.05 0-5.093.019-8.063-1.125a.75.75 0 0 1-.447-.515C3.262 16.255 3 14.678 3 12s.263-4.255.484-5.107a.75.75 0 0 1 .447-.518C6.792 5.27 11.587 5.25 11.979 5.25h.026c.05 0 5.098-.017 8.062 1.125a.75.75 0 0 1 .447.515c.224.855.486 2.432.486 5.11s-.262 4.255-.484 5.107v.004Z"
	  })));
	};

	exports.ArrowClockwiseIcon = SvgArrowClockwise;
	exports.ArrowElbowDownRightIcon = SvgArrowElbowDownRight;
	exports.ArrowLeftIcon = SvgArrowLeft;
	exports.ArrowMergeIcon = SvgArrowMerge;
	exports.ArrowRightIcon = SvgArrowRight;
	exports.ArrowSquareOutIcon = SvgArrowSquareOut;
	exports.ArrowUUpLeftIcon = SvgArrowUUpLeft;
	exports.ArrowUpLeftIcon = SvgArrowUpLeft;
	exports.ArrowUpRightIcon = SvgArrowUpRight;
	exports.ArrowsHorizontalLeftIcon = SvgArrowsHorizontalLeft;
	exports.ArrowsHorizontalRightIcon = SvgArrowsHorizontalRight;
	exports.BarcodeIcon = SvgBarcode;
	exports.BasketFillIcon = SvgBasketFill;
	exports.BasketIcon = SvgBasket;
	exports.BellFillIcon = SvgBellFill;
	exports.BellIcon = SvgBell;
	exports.BookOpenTextIcon = SvgBookOpenText;
	exports.BoyFillIcon = SvgBoyFill;
	exports.BuildingFillIcon = SvgBuildingFill;
	exports.BuildingIcon = SvgBuilding;
	exports.CalendarDotsFillIcon = SvgCalendarDotsFill;
	exports.CalendarDotsIcon = SvgCalendarDots;
	exports.CameraFillIcon = SvgCameraFill;
	exports.CameraIcon = SvgCamera;
	exports.CaretDownIcon = SvgCaretDown;
	exports.CaretRightIcon = SvgCaretRight;
	exports.CaretUpIcon = SvgCaretUp;
	exports.Caret_leftIcon = SvgCaretLeft;
	exports.ChatFillIcon = SvgChatFill;
	exports.CheckCircleFillIcon = SvgCheckCircleFill;
	exports.CheckCircleIcon = SvgCheckCircle;
	exports.CheckIcon = SvgCheck;
	exports.CheckSquareFillIcon = SvgCheckSquareFill;
	exports.CheckSquareIcon = SvgCheckSquare;
	exports.ClockFillIcon = SvgClockFill;
	exports.ClockIcon = SvgClock;
	exports.CookieFillIcon = SvgCookieFill;
	exports.CookieIcon = SvgCookie;
	exports.CopySimpleIcon = SvgCopySimple;
	exports.CreditCardFillIcon = SvgCreditCardFill;
	exports.CursorFillIcon = SvgCursorFill;
	exports.CursorIcon = SvgCursor;
	exports.DotsThreeOutlineFillIcon = SvgDotsThreeOutlineFill;
	exports.DotsThreeOutlineIcon = SvgDotsThreeOutline;
	exports.DownloadSimpleIcon = SvgDownloadSimple;
	exports.EnvelopeSimpleFillIcon = SvgEnvelopeSimpleFill;
	exports.EnvelopeSimpleIcon = SvgEnvelopeSimple;
	exports.EyeFillIcon = SvgEyeFill;
	exports.EyeIcon = SvgEye;
	exports.EyeSlashFillIcon = SvgEyeSlashFill;
	exports.EyeSlashIcon = SvgEyeSlash;
	exports.FacebookLogoFillIcon = SvgFacebookLogoFill;
	exports.FacebookLogoIcon = SvgFacebookLogo;
	exports.FemaleFillIcon = SvgFemaleFill;
	exports.FileFillIcon = SvgFileFill;
	exports.FileIcon = SvgFile;
	exports.GiftFillIcon = SvgGiftFill;
	exports.GiftIcon = SvgGift;
	exports.GirlFillIcon = SvgGirlFill;
	exports.GlobeIcon = SvgGlobe;
	exports.HeartFillIcon = SvgHeartFill;
	exports.HeartIcon = SvgHeart;
	exports.HouseFillIcon = SvgHouseFill;
	exports.HouseIcon = SvgHouse;
	exports.ImageFillIcon = SvgImageFill;
	exports.ImageIcon = SvgImage;
	exports.InfoFillIcon = SvgInfoFill;
	exports.InfoIcon = SvgInfo;
	exports.InstagramLogoFillIcon = SvgInstagramLogoFill;
	exports.InstagramLogoIcon = SvgInstagramLogo;
	exports.JuniorFillIcon = SvgJuniorFill;
	exports.KlarnaLogoFillIcon = SvgKlarnaLogoFill;
	exports.LeafFillIcon = SvgLeafFill;
	exports.LightbulbFillIcon = SvgLightbulbFill;
	exports.LightbulbIcon = SvgLightbulb;
	exports.LinkedinLogoFillIcon = SvgLinkedinLogoFill;
	exports.LinkedinLogoIcon = SvgLinkedinLogo;
	exports.ListBulletsIcon = SvgListBullets;
	exports.ListIcon = SvgList;
	exports.MagnifyingGlassIcon = SvgMagnifyingGlass;
	exports.MagnifyingGlassMinusFillIcon = SvgMagnifyingGlassMinusFill;
	exports.MagnifyingGlassMinusIcon = SvgMagnifyingGlassMinus;
	exports.MagnifyingGlassPlusFillIcon = SvgMagnifyingGlassPlusFill;
	exports.MagnifyingGlassPlusIcon = SvgMagnifyingGlassPlus;
	exports.MaleFillIcon = SvgMaleFill;
	exports.MapPinFillIcon = SvgMapPinFill;
	exports.MapPinIcon = SvgMapPin;
	exports.MinusCircleFillIcon = SvgMinusCircleFill;
	exports.MinusCircleIcon = SvgMinusCircle;
	exports.MinusIcon = SvgMinus;
	exports.PackageFillIcon = SvgPackageFill;
	exports.PackageIcon = SvgPackage;
	exports.PaperPlaneTiltFillIcon = SvgPaperPlaneTiltFill;
	exports.PaperPlaneTiltIcon = SvgPaperPlaneTilt;
	exports.PencilSimpleFillIcon = SvgPencilSimpleFill;
	exports.PencilSimpleIcon = SvgPencilSimple;
	exports.PhoneFillIcon = SvgPhoneFill;
	exports.PhoneIcon = SvgPhone;
	exports.PinterestLogoFillIcon = SvgPinterestLogoFill;
	exports.PinterestLogoIcon = SvgPinterestLogo;
	exports.PlayCircleFillIcon = SvgPlayCircleFill;
	exports.PlayCircleIcon = SvgPlayCircle;
	exports.PlusCircleFillIcon = SvgPlusCircleFill;
	exports.PlusCircleIcon = SvgPlusCircle;
	exports.PlusIcon = SvgPlus;
	exports.PrinterFillIcon = SvgPrinterFill;
	exports.PrinterIcon = SvgPrinter;
	exports.RadioButtonFillIcon = SvgRadioButtonFill;
	exports.RadioButtonIcon = SvgRadioButton;
	exports.RulerFillIcon = SvgRulerFill;
	exports.RulerIcon = SvgRuler;
	exports.ShoppingCartFillIcon = SvgShoppingCartFill;
	exports.ShoppingCartIcon = SvgShoppingCart;
	exports.SlidersHorizontalFillIcon = SvgSlidersHorizontalFill;
	exports.SlidersHorizontalIcon = SvgSlidersHorizontal;
	exports.SquareIcon = SvgSquare;
	exports.StarFillIcon = SvgStarFill;
	exports.StarIcon = SvgStar;
	exports.StorefrontFillIcon = SvgStorefrontFill;
	exports.StorefrontIcon = SvgStorefront;
	exports.StravaLogoFillIcon = SvgStravaLogoFill;
	exports.TShirtFillIcon = SvgTShirtFill;
	exports.TShirtIcon = SvgTShirt;
	exports.TagFillIcon = SvgTagFill;
	exports.TagIcon = SvgTag;
	exports.TicketFillIcon = SvgTicketFill;
	exports.TicketIcon = SvgTicket;
	exports.TiktokLogoFillIcon = SvgTiktokLogoFill;
	exports.TiktokLogoIcon = SvgTiktokLogo;
	exports.TrashFillIcon = SvgTrashFill;
	exports.TrashIcon = SvgTrash;
	exports.TruckFillIcon = SvgTruckFill;
	exports.TruckIcon = SvgTruck;
	exports.UnisexFillIcon = SvgUnisexFill;
	exports.UserCheckFillIcon = SvgUserCheckFill;
	exports.UserCheckIcon = SvgUserCheck;
	exports.UserFillIcon = SvgUserFill;
	exports.UserIcon = SvgUser;
	exports.UsersFillIcon = SvgUsersFill;
	exports.UsersIcon = SvgUsers;
	exports.WarningCircleFillIcon = SvgWarningCircleFill;
	exports.WarningCircleIcon = SvgWarningCircle;
	exports.WarningFillIcon = SvgWarningFill;
	exports.WarningIcon = SvgWarning;
	exports.WhatsappLogoFillIcon = SvgWhatsappLogoFill;
	exports.WhatsappLogoIcon = SvgWhatsappLogo;
	exports.XIcon = SvgX;
	exports.XLogoFillIcon = SvgXLogoFill;
	exports.XLogoIcon = SvgXLogo;
	exports.YoutubeLogoFillIcon = SvgYoutubeLogoFill;
	exports.YoutubeLogoIcon = SvgYoutubeLogo;

}));
